// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Poppins-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Poppins-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Poppins-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Poppins-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Poppins-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Poppins-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Poppins-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Poppins-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 viewBox=%270 0 20 20%27 fill-rule=%27evenodd%27%3E%3Cpath d=%27M16.036 18.455l2.404-2.405 5.586 5.587-2.404 2.404zM8.5 2C12.1 2 15 4.9 15 8.5S12.1 15 8.5 15 2 12.1 2 8.5 4.9 2 8.5 2zm0-2C3.8 0 0 3.8 0 8.5S3.8 17 8.5 17 17 13.2 17 8.5 13.2 0 8.5 0zM15 16a1 1 0 1 1 2 0 1 1 0 1 1-2 0%27%3E%3C/path%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/04/Rectangle1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/01/dots.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/01/login-head.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "poppins Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "poppins Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "poppins Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "poppins Semibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
/*VARIABLES*/
/* MIXINS */
/* RESET CSS */
/* http://meyerweb.com/eric/tools/css/reset/
  v2.0 | 20110126
  License: none (public domain)
  */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  color: inherit;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
  overflow: scroll;
  overflow-x: hidden;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

* {
  box-sizing: border-box;
}

a {
  text-decoration: none;
}
a, a:hover, a:active, a:visited, a:focus {
  color: inherit;
}

i,
em,
.italic-text {
  font-style: italic;
}

.left {
  float: left;
}

.right {
  float: right;
}

.wrap-clear::after {
  content: "";
  display: block;
  clear: both;
}

.clearfix {
  zoom: 1;
  display: table;
  clear: both;
}
.clearfix:before, .clearfix:after {
  content: "";
  display: table;
}
.clearfix:after {
  clear: both;
}

:focus {
  outline: none;
}

input,
button,
textarea {
  border-radius: 0;
  appearance: none;
}

select {
  border-radius: 0;
  background-color: white;
}

textarea {
  resize: none;
}

/* COMMONS */
body {
  -webkit-font-smoothing: antialiased;
  letter-spacing: 0.6px;
  -webkit-user-select: none;
}

ol,
ul {
  margin: 0px;
}

button,
input,
select,
textarea {
  -webkit-appearance: none;
  outline: none;
  border-radius: 0;
  background-color: transparent;
}

input,
textarea {
  background: transparent;
  border: none;
}

input:focus,
select:focus,
textarea:focus,
button:focus,
a:focus {
  outline: none;
}

a {
  color: inherit;
  cursor: pointer;
}

.h1,
.h2,
.h3,
.h4,
h1,
h2,
h3,
h4 {
  line-height: 1.2;
}

p {
  line-height: 1.4;
}

img {
  display: block;
  max-width: 100%;
  height: auto;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.slick-next:before,
.slick-prev:before {
  content: "";
}

.scroll-lock {
  height: 100%;
  overflow-y: hidden;
}
small {
  font-size: 13px;
}

.input[type=checkbox] {
  -webkit-appearance: checkbox;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

@media only screen and (min-width: 1025px) {
  .hidden-lg {
    display: none !important;
  }
}

@media (max-width: 767px) {
  .hidden-xs {
    display: none !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .hidden-md {
    display: none !important;
  }
}

.img-responsive {
  width: 100%;
  height: auto;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  width: 90%;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .container {
    width: 90%;
    max-width: 768px;
  }
}
@media (max-width: 767px) {
  .container {
    width: 100%;
    margin: 0 auto;
    padding: 0 15px;
  }
}

body {
  font-family: "poppins Light";
}

.tabs {
  margin-top: 20px;
  font-family: "poppins Light";
}
@media (max-width: 767px) {
  .tabs {
    margin-top: 10px;
  }
}

.tab-buttons {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.tab-buttons button {
  padding: 10px 20px;
  margin: 0 5px;
  border: none;
  cursor: pointer;
  background-color: #f0f0f0;
  transition: background-color 0.3s;
}

.tab-buttons button.active {
  background-color: #007bff;
  color: white;
}

.tab-buttons button:hover {
  background-color: #e0e0e0;
}

.tab-content {
  padding: 20px;
  border: 1px solid #f0f0f0;
  background-color: #fafafa;
}

.accordion-wrapper:not(:last-of-type) {
  border-bottom: 1px solid;
}
.accordion-wrapper + * {
  margin-top: 0.5em;
}

.accordion-item {
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(1, 0, 1, 0);
  height: auto;
  max-height: 9999px;
}

.accordion-item.collapsed {
  max-height: 0;
  transition: max-height 0.35s cubic-bezier(0, 1, 0, 1);
}

.accordion-title {
  font-family: "poppins Regular";
  font-weight: 600;
  cursor: pointer;
  color: #666;
  padding: 20px 0;
  padding-bottom: 15px;
  border-radius: 1.5em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  position: relative;
}
.accordion-title span {
  font-size: 26px;
}
@media (max-width: 767px) {
  .accordion-title span {
    font-size: 18px;
  }
}
.accordion-title svg {
  position: absolute;
  top: 20px;
  right: 0px;
  font-size: 20px;
}
.accordion-title:hover, .accordion-title.open {
  color: black;
}
.accordion-content {
  padding: 1em 10px;
  padding-top: 0px;
  font-family: "poppins Regular";
  line-height: 1.4;
  font-size: 20px;
}
@media (max-width: 767px) {
  .accordion-content {
    font-size: 16px;
  }
}

.react-tabs__tab {
  background-color: #fedeff;
  border-radius: 30px;
  padding: 10px 35px;
  font: 18px "poppins Semibold";
  text-transform: uppercase;
  width: 260px;
  text-align: center;
}
@media (max-width: 767px) {
  .react-tabs__tab {
    padding: 5px 25px;
    font-size: 14px;
    width: 160px;
  }
}
.react-tabs__tab:hover {
  border: 1px solid black;
  box-shadow: 2px 2px black;
  transition: 0.3s;
}

.react-tabs__tab--selected {
  background: #fddefe;
  border: 1px solid black;
  font-family: "poppins Semibold";
  border-radius: 30px;
  box-shadow: 2px 2px black;
}
.react-tabs__tab--selected:focus {
  outline: unset;
}

.react-tabs__tab:focus:after {
  content: "";
  position: unset;
  height: 0;
  left: unset;
  right: unset;
  bottom: unset;
  background: transparent;
}

.react-tabs__tab-list {
  margin: 0;
  border: none;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .react-tabs__tab-list {
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;
  }
  .react-tabs__tab-list .react-tabs__tab {
    flex-basis: 48%;
  }
}

.react-tabs__tab-panel--selected {
  background: #fddefe;
  padding: 20px;
  border: 1px solid black;
  border-radius: 20px;
}
.react-tabs__tab-panel--selected:focus {
  border: none;
  padding: 0;
}

.agency-partner-section {
  padding-top: 180px;
}
@media (max-width: 767px) {
  .agency-partner-section {
    padding-top: 120px;
  }
}
.agency-partner-section .agps-wrapper .search-component {
  margin-bottom: 40px;
}
@media (max-width: 767px) {
  .agency-partner-section .agps-wrapper .search-component {
    margin-bottom: 20px;
  }
}
.agency-partner-section .agps-wrapper .search-component .max-width-11 {
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
}
@media (max-width: 767px) {
  .agency-partner-section .agps-wrapper .search-component .max-width-11 {
    margin-bottom: 10px;
  }
}
.agency-partner-section .agps-wrapper .search-component h1 {
  font: 30px "poppins Regular";
}
@media (max-width: 767px) {
  .agency-partner-section .agps-wrapper .search-component h1 {
    font-size: 23px;
  }
}
.agency-partner-section .agps-wrapper .search-component h3 {
  font: 50px "poppins Semibold";
}
@media (max-width: 767px) {
  .agency-partner-section .agps-wrapper .search-component h3 {
    font-size: 24px;
    line-height: 1.1;
    margin-bottom: 10px;
  }
}
.agency-partner-section .agps-wrapper .search-component p {
  font: 20px "poppins Regular";
  margin-bottom: 60px;
}
@media (max-width: 767px) {
  .agency-partner-section .agps-wrapper .search-component p {
    font-size: 14px;
  }
}
.agency-partner-section .agps-wrapper .search-label {
  position: relative;
}
.agency-partner-section .agps-wrapper .search-label::before {
  content: "";
  position: absolute;
  left: 5px;
  top: 0;
  bottom: 0;
  width: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) center/contain no-repeat;
}
@media (max-width: 767px) {
  .agency-partner-section .agps-wrapper .search-label::before {
    width: 14px;
    top: 5px;
  }
}
.agency-partner-section .agps-wrapper .search-label input {
  padding: 8px 10px;
  padding-left: 35px;
  border: none;
  border-bottom: 1px solid;
  width: 100%;
  font: 20px "poppins Regular";
}
.agency-partner-section .agps-wrapper .search-label input:focus {
  outline: none;
}
@media (max-width: 767px) {
  .agency-partner-section .agps-wrapper .search-label input {
    font-size: 14px;
    padding: 5px 10px;
    padding-left: 25px;
    margin-top: 10px;
  }
}
.agency-partner-section .agps-wrapper .search-label svg.fa-xmark {
  position: absolute;
  right: 0px;
  top: 0px;
  transition: all 0.2s ease;
  cursor: pointer;
  padding: 8px 10px;
}
.agency-partner-section .agps-wrapper .search-label svg.fa-xmark:hover {
  color: gray;
}
.agency-partner-section .agps-wrapper .filter-wrap {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  align-items: stretch;
  gap: 20px;
}
.agency-partner-section .agps-wrapper .filter-wrap .tabs {
  flex: 1 1;
}
@media (max-width: 767px) {
  .agency-partner-section .agps-wrapper .filter-wrap {
    flex-direction: column-reverse;
  }
}
.agency-partner-section .agps-wrapper .apply-filters {
  border: 1px solid;
  padding: 4px 8px;
  border-radius: 5px;
}
.agency-partner-section .agps-wrapper .apply-filters:hover {
  background-color: black;
  color: white;
  transition: 0.3s;
}
.agency-partner-section .agps-wrapper .filter-actions {
  display: flex;
  align-items: center;
  gap: 20px;
  align-self: flex-end;
}
@media (max-width: 767px) {
  .agency-partner-section .agps-wrapper .filter-actions {
    align-self: center;
  }
}
.agency-partner-section .agps-wrapper .clear-filters {
  border-bottom: 1px solid black;
}
.agency-partner-section .agps-wrapper .clear-filters:hover {
  font-weight: 900;
  transition: 0.3s;
  transition: 0.3s;
}
.agency-partner-section .agps-wrapper .agency-container {
  max-width: 1200px;
  padding: 0 15px;
  margin: 0 auto;
}
.agency-partner-section .agps-wrapper .agency-results {
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
  padding-top: 40px;
  padding-bottom: 40px;
}
@media (max-width: 767px) {
  .agency-partner-section .agps-wrapper .agency-results {
    align-items: center;
    flex-direction: row;
    gap: 20px;
  }
}
.agency-partner-section .agps-wrapper .agency-results .view-link {
  flex-basis: 30%;
}
@media (max-width: 767px) {
  .agency-partner-section .agps-wrapper .agency-results .view-link {
    flex-basis: calc(50% - 10px);
    display: flex;
    align-items: center;
  }
}
.agency-partner-section .agps-wrapper .agency-results .agency-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 10rem;
  padding: 1rem 1.375rem;
  background-color: #fddefe;
  border-radius: 10px;
  border: 2px solid black;
  transition: 0.3s;
}
.agency-partner-section .agps-wrapper .agency-results .agency-wrapper .adress-wrapper {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
@media (max-width: 767px) {
  .agency-partner-section .agps-wrapper .agency-results .agency-wrapper {
    gap: 10px;
    flex-grow: 1;
  }
}
.agency-partner-section .agps-wrapper .agency-results .agency-wrapper h3 {
  font-size: 20px;
  margin-top: 0;
}
.agency-partner-section .agps-wrapper .agency-results .agency-wrapper p {
  font-size: 16px;
  margin-top: 0;
}
@media (max-width: 767px) {
  .agency-partner-section .agps-wrapper .agency-results .agency-wrapper p {
    font-size: 14px;
  }
}
.agency-partner-section .agps-wrapper .agency-results .agency-wrapper div.view-copy {
  text-decoration: underline;
  text-transform: uppercase;
  align-self: flex-end;
}
@media (max-width: 767px) {
  .agency-partner-section .agps-wrapper .agency-results .agency-wrapper div.view-copy {
    font-size: 14px;
  }
}
.agency-partner-section .agps-wrapper .agency-results .agency-wrapper:hover {
  background-color: black;
  color: #fddefe;
}
.agency-partner-section .agps-wrapper .tablist-wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.agency-partner-section .agps-wrapper .tablist-wrap li {
  margin-bottom: 10px;
}
.agency-partner-section .agps-wrapper .tablist-wrap li a {
  padding: 4px 6px;
  font-family: "poppins Semibold";
  font-size: 16px;
  border-radius: 5px;
  transition: all 0.3s ease;
}
.agency-partner-section .agps-wrapper .tablist-wrap li a:hover {
  background: #d8d8d8;
}
.agency-partner-section .agps-wrapper .tablist-wrap li.active a {
  background: #000000;
  color: white;
}
.agency-partner-section .search-results {
  position: relative;
  min-height: 200px;
}
.agency-partner-section .empty-results {
  font-family: "poppins Light";
  font-size: 20px;
  margin-top: 40px;
}

.login-page {
  font-family: "poppins Regular";
}

header {
  position: fixed;
  transition: top 0.6s ease-in-out;
  left: 0;
  right: 0;
  padding-top: 20px;
  padding-bottom: 20px;
  z-index: 5000;
  background-color: #fedfff;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
@media (max-width: 767px) {
  header {
    z-index: 5000;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header {
    padding-top: 15px;
    padding-bottom: 10px;
  }
}
header .header-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* Hamburger Styling */
  /* Mobile Menu */
}
header .header-main .nav-menu {
  display: flex;
  list-style: none;
}
header .header-main .nav-item {
  margin-right: 20px;
}
header .header-main .nav-link {
  text-decoration: none;
  color: black;
  transition: color 0.3s ease;
}
header .header-main .nav-link:hover {
  color: grey;
}
header .header-main .hamburger {
  display: none;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
}
header .header-main .hamburger .bar {
  width: 25px;
  height: 2px;
  background-color: black;
  margin: 3px 0;
  transition: all 0.3s ease;
}
header .header-main .hamburger.active .bar:nth-child(1) {
  transform: rotate(-45deg) translate(-5px, 6px);
}
header .header-main .hamburger.active .bar:nth-child(2) {
  opacity: 0;
}
header .header-main .hamburger.active .bar:nth-child(3) {
  transform: rotate(45deg) translate(-5px, -6px);
}
@media (max-width: 768px) {
  header .header-main .hamburger {
    display: flex;
  }
  header .header-main .nav-menu {
    display: none;
    flex-direction: column;
    width: 100%;
    position: absolute;
    top: 60px;
    left: 0;
    background-color: white;
    border-top: 1px solid #ddd;
  }
  header .header-main .nav-menu.active {
    display: flex;
    z-index: 1;
  }
  header .header-main .nav-item {
    margin: 0;
    text-align: center;
    padding: 15px 0;
    border-bottom: 1px solid #ddd;
  }
  header .header-main .nav-link {
    color: black;
  }
}
header .header-main a {
  display: inline-block;
  text-transform: capitalize;
  font: 18px "poppins Medium";
  color: black;
  display: block;
  display: inline-block;
}
header .header-main a #logo-brand {
  transition: 0.6s;
}
header .header-main a img {
  display: inline-block;
  width: 83px;
}
@media (max-width: 767px) {
  header .header-main a img {
    width: 70px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main a img {
    width: 61px;
  }
}
@media (max-width: 767px) {
  header .header-main a {
    font-size: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main a {
    font-size: 24px;
  }
}
header .header-main .logout-btn {
  border: 1px solid black;
  padding: 5px 15px;
  border-radius: 20px;
  cursor: pointer;
  font: 16px "poppins Regular";
}
header .header-main .logout-btn:hover {
  background-color: black;
  color: #fedeff;
  transition: all 0.3s ease;
}
header .header-main .brand {
  font-size: 0;
  z-index: 10;
}
header .header-main .nav-menu {
  display: flex;
  align-items: center;
  gap: 2.5rem;
}
@media (max-width: 767px) {
  header .header-main .nav-menu {
    padding-top: 100px;
    z-index: -1;
    position: fixed;
    left: -100%;
    top: 0px;
    gap: 0;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    text-align: center;
    transition: 0.3s;
    overflow: hidden;
    background-color: #f8dffd;
  }
  header .header-main .nav-menu.active {
    left: 0;
  }
}
@media (max-width: 767px) and (max-width: 767px) {
  header .header-main .nav-menu.active {
    padding-top: 100px;
  }
}
@media (max-width: 767px) {
  header .header-main .nav-menu .nav-item {
    margin: 16px 0;
  }
}
@media (max-width: 767px) and (max-width: 767px) {
  header .header-main .nav-menu .nav-item {
    margin: 10px 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main .nav-menu {
    z-index: -1;
    position: fixed;
    left: -100%;
    top: 100px;
    gap: 0;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    text-align: center;
    transition: 0.3s;
  }
  header .header-main .nav-menu.active {
    left: 0;
    padding-top: 3rem;
  }
  header .header-main .nav-menu .nav-item {
    margin: 10px 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main .nav-item {
    line-height: 2;
  }
}
header .header-main .nav-item .nav-link {
  display: inline-block;
  position: relative;
}
header .header-main .nav-item .nav-link:after {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 2px;
  bottom: -18px;
  left: 0;
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}
header .header-main .nav-item .nav-link:hover::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}
header .header-main .join-now {
  font-size: 18px;
  border-radius: 25px 0 25px 0;
  padding: 15px 40px;
}
@media (max-width: 767px) {
  header .header-main .join-now {
    border-radius: 20px 0 20px 0;
    padding: 10px 20px;
  }
}
header .header-main .join-now:hover {
  color: #11173e;
  transition: all 0.35s ease-in-out;
}
header .header-main .hamburger {
  display: none;
  cursor: pointer;
  border-radius: 50%;
  padding: 13px 15px;
  z-index: 10;
}
header .header-main .hamburger .bar {
  display: block;
  width: 20px;
  height: 3px;
  margin: 5px auto;
  transition: all 0.3s ease-in-out;
  background-color: black;
}
header .header-main .hamburger .bar:nth-child(1) {
  opacity: 0;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main .hamburger .bar {
    width: 35px;
  }
}
header .header-main .hamburger .bar.bar-1 {
  margin: 0;
}
@media (max-width: 767px) {
  header .header-main .hamburger {
    display: block;
  }
  header .header-main .hamburger.active .bar:nth-child(1) {
    opacity: 1;
    transform: translate(0px, 8px) rotate(45deg);
  }
  header .header-main .hamburger.active .bar:nth-child(2) {
    opacity: 0;
  }
  header .header-main .hamburger.active .bar:nth-child(3) {
    transform: translate(0px, -8px) rotate(-45deg);
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main .hamburger {
    display: block;
  }
  header .header-main .hamburger.active .bar:nth-child(1) {
    opacity: 1;
    transform: translate(0px, 8px) rotate(45deg);
  }
  header .header-main .hamburger.active .bar:nth-child(2) {
    opacity: 0;
  }
  header .header-main .hamburger.active .bar:nth-child(3) {
    transform: translate(0px, -8px) rotate(-45deg);
  }
}

footer {
  padding: 4rem 0;
  padding-top: 6rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-size: 100%;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  overflow: hidden;
  left: 0;
  bottom: 0;
  right: 0;
}
@media (max-width: 767px) {
  footer {
    background-size: cover;
    padding: 2rem 0;
    padding-top: 6rem;
  }
}
footer .footer-bg-shape {
  position: absolute;
  position: absolute;
  bottom: -54%;
  right: 10%;
  width: 500px;
  z-index: 1;
}
@media (max-width: 767px) {
  footer .footer-bg-shape {
    width: 240px;
    bottom: 0;
    left: 0%;
  }
}
footer .footer-wrapper {
  position: relative;
  z-index: 10;
  padding-top: 2rem;
  display: flex;
  justify-content: space-between;
}
@media (max-width: 767px) {
  footer .footer-wrapper {
    flex-direction: column-reverse;
    gap: 1rem;
  }
}
footer .footer-wrapper h3 {
  font-family: "poppins Regular";
  font-size: 2rem;
}
@media (max-width: 767px) {
  footer .footer-wrapper h3 {
    font-size: 1.1rem;
  }
}
footer .footer-wrapper h4 {
  font-family: "poppins Medium";
  font-size: 1.2rem;
}
@media (max-width: 767px) {
  footer .footer-wrapper h4 {
    font-size: 14px;
  }
}
footer .footer-wrapper h4.email-id {
  font-family: "poppins Regular";
  margin-top: 1rem;
}
@media (max-width: 767px) {
  footer .footer-wrapper h4.email-id {
    margin-top: 5px;
  }
}
footer .footer-wrapper .wrapper-item {
  flex: 1 1;
}
footer .footer-wrapper .wrapper-item-1 {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
}
@media (max-width: 767px) {
  footer .footer-wrapper .wrapper-item-1 {
    justify-content: flex-start;
    gap: 1rem;
  }
}
footer .footer-wrapper .wrapper-item-1 li {
  font-family: "poppins Regular";
  font-size: 1.4rem;
}
@media (max-width: 767px) {
  footer .footer-wrapper .wrapper-item-1 li {
    font-size: 14px;
  }
}

main {
  justify-content: center;
  align-items: center;
}

.login-page {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}), url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-position: top;
  background-size: 100%, 100% 55%;
  background-repeat: no-repeat;
}
.login-page .wrapper-login {
  width: 100%;
}
.login-page .wrapper-login .hero-section {
  padding-top: 99px;
  padding-bottom: 40px;
}
.login-page .wrapper-login .hero-section .hero-copy {
  text-align: center;
}
.login-page .wrapper-login .hero-section .hero-copy h2 {
  margin-top: 20px;
  font-family: "poppins Semibold";
  font-size: 60px;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .login-page .wrapper-login .hero-section .hero-copy h2 {
    font-size: 26px;
    margin: 10px 0;
  }
}
.login-page .wrapper-login .hero-section .hero-copy p {
  font-family: "poppins Regular";
  font-size: 24px;
}
@media (max-width: 767px) {
  .login-page .wrapper-login .hero-section .hero-copy p {
    font-size: 16px;
  }
}
.login-page .back-shape {
  position: absolute;
  right: 450px;
  top: 350px;
  width: 300px;
}
.login-page .form-wrapper {
  position: relative;
  border: 1px solid black;
  border-radius: 20px;
  padding: 35px;
  max-width: 500px;
  height: 450px;
  margin-bottom: 60px;
  box-shadow: 8px 8px black;
  background-color: white;
}
@media (max-width: 767px) {
  .login-page .form-wrapper {
    max-width: 325px;
    padding: 25px;
    height: 360px;
  }
}
.login-page .form-wrapper .login-copy {
  font-family: "poppins Semibold";
  text-align: center;
  font-size: 34px;
}
@media (max-width: 767px) {
  .login-page .form-wrapper .login-copy {
    font-size: 24px;
  }
}
.login-page .form-wrapper .err-inpt-wrap {
  position: relative;
}
.login-page .form-wrapper .err-inpt-wrap .err-div {
  position: absolute;
  font-size: 12px;
  color: rgb(255, 0, 0);
}
@media (max-width: 767px) {
  .login-page .form-wrapper .err-inpt-wrap .err-div {
    font-size: 14px;
  }
}
.login-page .form-wrapper .input-field {
  width: 100%;
  font-family: "poppins Regular";
  color: black;
  font-size: 20px;
  border-bottom: 1px solid black;
  margin-bottom: 10px;
  margin-top: 40px;
}
@media (max-width: 767px) {
  .login-page .form-wrapper .input-field {
    margin-top: 30px;
    font-size: 16px;
  }
}
.login-page .form-wrapper .btn {
  margin-top: 40px;
  width: 100%;
  border: 1px solid black;
  outline: none;
  padding: 10px 20px;
  font-size: 24px;
  background-color: #fedeff;
  border-radius: 10px;
  box-shadow: 2px 2px black;
  transition: 0.3s;
  cursor: pointer;
}
@media (max-width: 767px) {
  .login-page .form-wrapper .btn {
    margin-top: 30px;
    font-size: 16px;
  }
}
.login-page .form-wrapper .btn:hover {
  background-color: black;
  color: #fedeff;
}
.login-page .form-wrapper .forgot-copy {
  margin-top: 20px;
  text-align: center;
}
@media (max-width: 767px) {
  .login-page .form-wrapper .forgot-copy {
    font-size: 13px;
  }
}
.login-page .form-wrapper .forgot-copy span {
  display: inline-block;
  cursor: pointer;
}
.login-page .form-wrapper .forgot-copy span:hover {
  border-bottom: 1px solid black;
  transition: 0.1s;
}
.login-page .login-footer {
  position: relative;
  min-height: 90px;
}

.agency-wrapper {
  padding-top: 180px;
  padding-bottom: 50px;
}
@media (max-width: 767px) {
  .agency-wrapper {
    padding-top: 120px;
  }
}
.agency-wrapper .back-search {
  font-family: "poppins Semibold";
  font-size: 30px;
  margin-bottom: 40px;
  display: inline-block;
  transition: all 0.3s ease;
}
.agency-wrapper .back-search span {
  margin-right: 20px;
}
.agency-wrapper .back-search:hover {
  color: gray;
}
@media (max-width: 767px) {
  .agency-wrapper .back-search {
    margin-bottom: 30px;
    font-size: 18px;
  }
}
.agency-wrapper .banner-wrapper {
  display: flex;
  gap: 40px;
}
@media (max-width: 767px) {
  .agency-wrapper .banner-wrapper {
    flex-direction: column;
  }
}
.agency-wrapper .banner-wrapper .flex-copy {
  flex: 1.3 1;
}
.agency-wrapper .banner-wrapper .flex-copy h3 {
  font-family: "poppins Regular";
  font-size: 30px;
  margin-bottom: 10px;
}
@media (max-width: 767px) {
  .agency-wrapper .banner-wrapper .flex-copy h3 {
    font-size: 20px;
    margin-bottom: 10px;
  }
}
.agency-wrapper .banner-wrapper .flex-copy h4 {
  font-size: 70px;
  font-family: "poppins Semibold";
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .agency-wrapper .banner-wrapper .flex-copy h4 {
    font-size: 32px;
    margin-bottom: 10px;
  }
}
.agency-wrapper .banner-wrapper .flex-copy p {
  font-family: "poppins Regular";
  font-size: 20px;
}
@media (max-width: 767px) {
  .agency-wrapper .banner-wrapper .flex-copy p {
    font-size: 16px;
  }
}
.agency-wrapper .banner-wrapper .flex-logo {
  flex: 1 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
}
.agency-wrapper .banner-wrapper .flex-logo img {
  max-width: 240px;
}
.agency-wrapper .banner-wrapper .flex-logo .center-line {
  width: 100%;
  height: 1px;
  background-color: black;
}
.agency-wrapper .banner-wrapper .flex-logo .social-link-wrapper {
  display: flex;
  align-items: center;
  gap: 20px;
}
.agency-wrapper .banner-wrapper .flex-logo .social-link-wrapper .icon-link {
  font-size: 30px;
  transition: 0.3s;
}
@media (max-width: 767px) {
  .agency-wrapper .banner-wrapper .flex-logo .social-link-wrapper .icon-link {
    font-size: 25px;
  }
}
.agency-wrapper .banner-wrapper .flex-logo .social-link-wrapper .icon-link:hover {
  color: #666;
}
.agency-wrapper .banner-wrapper .flex-logo .social-link-wrapper .visit-link {
  border: 1px solid black;
  padding: 10px 30px;
  border-radius: 30px;
  font-size: 30px;
  font-family: "poppins Regular";
  display: inline-block;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: 0.3s;
}
@media (max-width: 767px) {
  .agency-wrapper .banner-wrapper .flex-logo .social-link-wrapper .visit-link {
    padding: 7px 12px;
  }
}
.agency-wrapper .banner-wrapper .flex-logo .social-link-wrapper .visit-link span {
  font-size: 16px;
}
@media (max-width: 767px) {
  .agency-wrapper .banner-wrapper .flex-logo .social-link-wrapper .visit-link span {
    font-size: 14px;
  }
}
.agency-wrapper .banner-wrapper .flex-logo .social-link-wrapper .visit-link:hover {
  background-color: black;
  color: white;
}

.acc-wrapper-section {
  padding: 50px 0;
  background-color: #fedeff;
}
@media (max-width: 767px) {
  .acc-wrapper-section {
    padding: 40px 0;
  }
}

.department-section {
  padding: 50px 0;
}
@media (max-width: 767px) {
  .department-section {
    padding: 40px 0;
  }
}
.department-section .department-wrapper .heading-dpt {
  font-family: "poppins Semibold";
  font-size: 40px;
  margin-bottom: 50px;
}
@media (max-width: 767px) {
  .department-section .department-wrapper .heading-dpt {
    font-size: 24px;
    margin-bottom: 20px;
  }
}
.department-section .department-wrapper .flex-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
}
.department-section .department-wrapper .flex-card .flex-1 {
  display: flex;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  background-color: #fedeff;
}
@media (max-width: 767px) {
  .department-section .department-wrapper .flex-card .flex-1 {
    flex-direction: column;
    padding: 20px 0;
  }
}
.department-section .department-wrapper .flex-card .card-item {
  flex: 1 0 28%;
  padding: 30px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
@media (max-width: 767px) {
  .department-section .department-wrapper .flex-card .card-item {
    padding: 10px 0;
    font-size: 16px;
  }
}

.agency-clients-section {
  padding: 50px 0;
}
@media (max-width: 767px) {
  .agency-clients-section {
    padding: 40px 0;
  }
}
.agency-clients-section .agency-clients-wrapper .heading-agcy {
  font-family: "poppins Semibold";
  font-size: 40px;
  margin-bottom: 50px;
}
@media (max-width: 767px) {
  .agency-clients-section .agency-clients-wrapper .heading-agcy {
    font-size: 24px;
    margin-bottom: 20px;
  }
}
.agency-clients-section .agency-clients-wrapper .client-filters {
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding: 40px 20px;
  background-color: #fedeff;
  justify-content: space-between;
  border: black 1px solid;
}
@media (max-width: 767px) {
  .agency-clients-section .agency-clients-wrapper .client-filters {
    flex-direction: column;
    align-items: center;
    padding: 20px;
    gap: 20px;
  }
}
.agency-clients-section .agency-clients-wrapper .client-filters .select-wrapper {
  position: relative;
  border-bottom: 1px solid black;
  transition: 0.3s;
}
.agency-clients-section .agency-clients-wrapper .client-filters .select-wrapper select {
  cursor: pointer;
  border: none;
  font: 22px "poppins Semibold";
  padding-right: 35px;
  position: relative;
  z-index: 200;
  transition: 0.3s;
}
.agency-clients-section .agency-clients-wrapper .client-filters .select-wrapper select option {
  font-family: "poppins Regular";
}
@media (max-width: 767px) {
  .agency-clients-section .agency-clients-wrapper .client-filters .select-wrapper select {
    font-size: 18px;
  }
}
.agency-clients-section .agency-clients-wrapper .client-filters .select-wrapper select:hover {
  color: #666;
}
.agency-clients-section .agency-clients-wrapper .client-filters .select-wrapper .fevicon-arrow {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-block;
}
.agency-clients-section .agency-clients-wrapper .client-filters .select-wrapper:hover {
  color: #666;
}
.agency-clients-section .agency-clients-wrapper .client-filters .select-wrap {
  padding: 5px 10px;
  align-items: center;
}
.agency-clients-section .agency-clients-wrapper .client-filters .btn-agcy {
  font: 20px "poppins Semibold";
  transition: 0.3s;
}
@media (max-width: 767px) {
  .agency-clients-section .agency-clients-wrapper .client-filters .btn-agcy {
    font-size: 16px;
  }
}
.agency-clients-section .agency-clients-wrapper .client-filters .btn-agcy:hover {
  color: #666;
}
.agency-clients-section .client-list {
  padding: 40px 20px;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  position: relative;
  min-height: 120px;
}
.agency-clients-section .btn-clear-agcy {
  transition: all 0.2s ease;
  text-decoration: underline;
  font-size: 14px;
}
.agency-clients-section .btn-clear-agcy:hover {
  color: gray;
}
.agency-clients-section .agency-client-column li {
  margin-bottom: 10px;
}
@media only screen and (min-width: 1025px) {
  .agency-clients-section .cta-wrap {
    display: flex;
    justify-content: flex-end;
    flex: 0.2 1;
  }
}

.select-work-section {
  padding-top: 50px;
  padding-bottom: 50px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-size: 100% 60%;
  background-position-y: 60%;
  background-repeat: no-repeat;
}
.select-work-section .select-work-wrapper .slider-head-copy {
  font-size: 40px;
  font-family: "poppins Semibold";
}
@media (max-width: 767px) {
  .select-work-section .select-work-wrapper .slider-head-copy {
    font-size: 24px;
  }
}
.select-work-section .select-work-wrapper .slider-container {
  position: relative;
  overflow: hidden;
}
@media (max-width: 767px) {
  .select-work-section .select-work-wrapper .slider-container {
    padding: 30px 0;
  }
}
.select-work-section .select-work-wrapper .slider-container .flex-slide-item {
  display: flex !important;
  justify-content: space-around;
  align-items: center;
}
@media (max-width: 767px) {
  .select-work-section .select-work-wrapper .slider-container .flex-slide-item {
    flex-direction: column;
  }
}
.select-work-section .select-work-wrapper .slider-container .flex-slide-item .left-copy {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding-bottom: 40px;
}
@media (max-width: 767px) {
  .select-work-section .select-work-wrapper .slider-container .flex-slide-item .left-copy {
    flex: 1 1;
  }
}
.select-work-section .select-work-wrapper .slider-container .flex-slide-item .left-copy .head-wrap {
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 20px;
}
.select-work-section .select-work-wrapper .slider-container .flex-slide-item .left-copy .head-wrap .tag {
  font-family: "poppins Regular";
  text-transform: capitalize;
}
.select-work-section .select-work-wrapper .slider-container .flex-slide-item .left-copy .head-wrap .title {
  font-family: "poppins Light";
  text-transform: capitalize;
}
@media (max-width: 767px) {
  .select-work-section .select-work-wrapper .slider-container .flex-slide-item .left-copy .head-wrap {
    font-size: 18px;
  }
}
.select-work-section .select-work-wrapper .slider-container .flex-slide-item .left-copy .link-project {
  background-color: black;
  color: white;
  border-radius: 20px;
  padding: 8px 20px;
  font-family: "poppins Semibold";
  font-size: 20px;
  margin-top: 20px;
  transition: 0.3s;
}
.select-work-section .select-work-wrapper .slider-container .flex-slide-item .left-copy .link-project:hover {
  background-color: white;
  color: black;
}
@media (max-width: 767px) {
  .select-work-section .select-work-wrapper .slider-container .flex-slide-item .left-copy .link-project {
    font-size: 16px;
  }
}
.select-work-section .select-work-wrapper .slider-container .flex-slide-item .img-slider {
  flex: 2 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.select-work-section .select-work-wrapper .slider-container .flex-slide-item .img-slider img {
  border-radius: 10px;
}
.select-work-section .select-work-wrapper .slider-container .slick-track,
.select-work-section .select-work-wrapper .slider-container .slick-list {
  -webkit-perspective: 2000px;
  -webkit-backface-visibility: hidden;
  display: flex;
  align-items: center;
}
.select-work-section .select-work-wrapper .slider-container .control-wrappar {
  position: absolute;
  bottom: 100px;
  left: 280px;
}
@media (max-width: 767px) {
  .select-work-section .select-work-wrapper .slider-container .control-wrappar {
    top: 135px;
    right: 50px;
    left: unset;
  }
}
.select-work-section .select-work-wrapper .slider-container .control-wrappar button {
  border: none;
  cursor: pointer;
  font-size: 20px;
}

.spinner {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.spinner span {
  display: block;
  width: 30px;
  height: 30px;
  border: 3px solid transparent;
  border-radius: 50%;
  border-right-color: rgba(0, 0, 0, 0.7019607843);
  animation: spinner-anim 0.8s linear infinite;
}
.spinner.spinner-int {
  top: 85%;
}
.spinner.spinner-news {
  top: 85%;
}

@keyframes spinner-anim {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.reset-page {
  padding-top: 120px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}), url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-position: top;
  background-size: 100%, 100% 80%;
  background-repeat: no-repeat;
}
.reset-page .wrapper-login {
  width: 100%;
}
.reset-page .wrapper-login .hero-section {
  padding-bottom: 40px;
}
.reset-page .wrapper-login .hero-section .hero-copy {
  text-align: center;
}
.reset-page .wrapper-login .hero-section .hero-copy h2 {
  margin-top: 20px;
  font-family: "poppins Semibold";
  font-size: 60px;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .reset-page .wrapper-login .hero-section .hero-copy h2 {
    font-size: 26px;
    margin: 10px 0;
  }
}
.reset-page .wrapper-login .hero-section .hero-copy p {
  font-family: "poppins Regular";
  font-size: 24px;
}
@media (max-width: 767px) {
  .reset-page .wrapper-login .hero-section .hero-copy p {
    font-size: 16px;
  }
}
.reset-page .back-shape {
  position: absolute;
  right: 450px;
  top: 350px;
  width: 300px;
}
.reset-page .form-wrapper {
  position: relative;
  border: 1px solid black;
  border-radius: 20px;
  padding: 35px;
  max-width: 500px;
  height: 450px;
  margin-bottom: 60px;
  box-shadow: 8px 8px black;
  background-color: white;
}
@media (max-width: 767px) {
  .reset-page .form-wrapper {
    max-width: 325px;
    padding: 25px;
    height: unset;
  }
}
.reset-page .form-wrapper .login-copy {
  font-family: "poppins Semibold";
  text-align: center;
  font-size: 34px;
}
@media (max-width: 767px) {
  .reset-page .form-wrapper .login-copy {
    font-size: 24px;
  }
}
.reset-page .form-wrapper .login-para {
  font-size: 14px;
  text-align: center;
  margin-top: 20px;
}
.reset-page .form-wrapper .err-inpt-wrap {
  position: relative;
}
.reset-page .form-wrapper .err-inpt-wrap .err-div {
  position: absolute;
  font-size: 12px;
  color: rgb(255, 0, 0);
}
@media (max-width: 767px) {
  .reset-page .form-wrapper .err-inpt-wrap .err-div {
    font-size: 14px;
  }
}
.reset-page .form-wrapper .input-field {
  width: 100%;
  font-family: "poppins Regular";
  color: black;
  font-size: 20px;
  border-bottom: 1px solid black;
  margin-bottom: 10px;
  margin-top: 40px;
}
@media (max-width: 767px) {
  .reset-page .form-wrapper .input-field {
    margin-top: 30px;
    font-size: 16px;
  }
}
.reset-page .form-wrapper .btn {
  margin-top: 40px;
  width: 100%;
  border: 1px solid black;
  outline: none;
  padding: 10px 20px;
  font-size: 24px;
  background-color: #fedeff;
  border-radius: 10px;
  box-shadow: 2px 2px black;
  transition: 0.3s;
  cursor: pointer;
}
@media (max-width: 767px) {
  .reset-page .form-wrapper .btn {
    margin-top: 30px;
    font-size: 16px;
  }
}
.reset-page .form-wrapper .btn:hover {
  background-color: black;
  color: #fedeff;
}
.reset-page .form-wrapper .forgot-copy {
  margin-top: 20px;
  text-align: center;
}
@media (max-width: 767px) {
  .reset-page .form-wrapper .forgot-copy {
    font-size: 13px;
  }
}
.reset-page .form-wrapper .forgot-copy span {
  display: inline-block;
  cursor: pointer;
}
.reset-page .form-wrapper .forgot-copy span:hover {
  border-bottom: 1px solid black;
  transition: 0.1s;
}
.reset-page .login-footer {
  position: relative;
  min-height: 90px;
}

.not-found-container {
  padding-top: 140px;
  padding-bottom: 140px;
  max-width: 1200px;
  margin: 0 auto;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.not-found-container .copy-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.not-found-container .copy-wrap h1 {
  font-size: 34px;
  font-family: "poppins Semibold";
  margin-bottom: 10px;
}
.not-found-container .copy-wrap p {
  font-size: 20px;
  font-family: "poppins Medium";
}
.not-found-container a {
  border: 1px solid black;
  padding: 5px 15px;
  border-radius: 20px;
  cursor: pointer;
  font: 16px "poppins Regular";
  transition: all 0.3s ease;
  align-self: center;
}
.not-found-container a:hover {
  background: black;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/main.scss"],"names":[],"mappings":"AACA;EACE,4BAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;AADF;AAIA;EACE,8BAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAHF;AAMA;EACE,6BAAA;EACA,oHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AALF;AAQA;EACE,+BAAA;EACA,oHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAPF;AAUA,YAAA;AAOA,WAAA;AA0DA,cAAA;AAEA;;;GAAA;AAKA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,cAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;AAzEF;;AA6EA,gDAAA;AACA;;;;;;;;;;;EAWE,cAAA;AA1EF;;AA6EA;EACE,cAAA;EAEA,gBAAA;EACA,kBAAA;AA3EF;;AA8EA;;EAEE,gBAAA;AA3EF;;AA8EA;;EAEE,YAAA;AA3EF;;AA8EA;;;;EAIE,WAAA;EACA,aAAA;AA3EF;;AA8EA;EACE,yBAAA;EACA,iBAAA;AA3EF;;AA8EA;EACE,sBAAA;AA3EF;;AA8EA;EASE,qBAAA;AAnFF;AA2EE;EAKE,cAAA;AA7EJ;;AAmFA;;;EAGE,kBAAA;AAhFF;;AA0FA;EACE,WAAA;AAvFF;;AA0FA;EACE,YAAA;AAvFF;;AA0FA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AAvFF;;AA0FA;EACE,OAAA;EACA,cAAA;EACA,WAAA;AAvFF;AAyFE;EAEE,WAAA;EACA,cAAA;AAxFJ;AA2FE;EACE,WAAA;AAzFJ;;AA6FA;EACE,aAAA;AA1FF;;AA6FA;;;EAGE,gBAAA;EACA,gBAAA;AA1FF;;AA6FA;EACE,gBAAA;EACA,uBAAA;AA1FF;;AA6FA;EACE,YAAA;AA1FF;;AA6FA,YAAA;AAEA;EACE,mCAAA;EACA,qBAAA;EACA,yBAAA;AA3FF;;AA8FA;;EAEE,WAAA;AA3FF;;AA8FA;;;;EAIE,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;AA3FF;;AA8FA;;EAEE,uBAAA;EACA,YAAA;AA3FF;;AA8FA;;;;;EAKE,aAAA;AA3FF;;AA8FA;EACE,cAAA;EACA,eAAA;AA3FF;;AA8FA;;;;;;;;EAQE,gBAAA;AA3FF;;AA8FA;EACE,gBAAA;AA3FF;;AA8FA;EACE,cAAA;EACA,eAAA;EACA,YAAA;AA3FF;;AA8FA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AA3FF;;AA8FA,YAAA;AACA;EACE,0BAAA;AA3FF;;AA8FA;;EAEE,WAAA;AA3FF;;AA8FA;EACE,YAAA;EACA,kBAAA;AA3FF;AAkGA;EACE,eAAA;AAhGF;;AAmGA;EACE,4BAAA;EACA,sBAAA;AAhGF;;AAmGA;EACE,uBAAA;AAhGF;;AA3QI;EA8WJ;IAEI,wBAAA;EAhGF;AACF;;AAzRI;EA4XJ;IAEI,wBAAA;EAhGF;AACF;;AA3RI;EA8XJ;IAEI,wBAAA;EAhGF;AACF;;AAmGA;EACE,WAAA;EACA,YAAA;AAhGF;;AAmGA;EACE,iBAAA;EACA,cAAA;EACA,UAAA;AAhGF;AA5SI;EAyYJ;IAMI,UAAA;IACA,gBAAA;EA/FF;AACF;AAtTI;EA6YJ;IAWI,WAAA;IACA,cAAA;IACA,eAAA;EA9FF;AACF;;AAiGA;EACE,4BAzaM;AA2UR;;AAiGA;EACE,gBAAA;EACA,4BA9aM;AAgVR;AAtUI;EAkaJ;IAII,gBAAA;EA5FF;AACF;;AA+FA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA5FF;;AA+FA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,iCAAA;AA5FF;;AA+FA;EACE,yBAAA;EACA,YAAA;AA5FF;;AA+FA;EACE,yBAAA;AA5FF;;AA+FA;EACE,aAAA;EACA,yBAAA;EACA,yBAAA;AA5FF;;AAoGE;EACE,wBAAA;AAjGJ;AAmGE;EACE,iBAAA;AAjGJ;;AAqGA;EACE,gBAAA;EACA,oDAAA;EACA,YAAA;EACA,kBAAA;AAlGF;;AAqGA;EACE,aAAA;EACA,qDAAA;AAlGF;;AAqGA;EACE,8BA/eQ;EAgfR,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EAEA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAnGF;AAsGE;EACE,eAAA;AApGJ;AA9YI;EAifF;IAGI,eAAA;EAlGJ;AACF;AAqGE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AAnGJ;AA2GE;EAEE,YAAA;AA1GJ;AAyHA;EACE,iBAAA;EACA,gBAAA;EACA,8BAriBQ;EAsiBR,gBAAA;EACA,eAAA;AAvHF;AAnaI;EAqhBJ;IAOI,eAAA;EArHF;AACF;;AAuHA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;EAEA,YAAA;EACA,kBAAA;AArHF;AAlbI;EA+hBJ;IAUI,iBAAA;IACA,eAAA;IACA,YAAA;EAnHF;AACF;AAqHE;EACE,uBAAA;EACA,yBAAA;EACA,gBAAA;AAnHJ;;AAuHA;EACE,mBAAA;EACA,uBAAA;EACA,+BAnkBS;EAokBT,mBAAA;EACA,yBAAA;AApHF;AAqHE;EACE,cAAA;AAnHJ;;AAsHA;EACE,WAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AAnHF;;AAqHA;EACE,SAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AAlHF;AA3dI;EAwkBJ;IAOI,SAAA;IACA,uBAAA;IACA,eAAA;EAhHF;EAiHE;IACE,eAAA;EA/GJ;AACF;;AAkHA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA/GF;AAgHE;EACE,YAAA;EACA,UAAA;AA9GJ;;AAkHA;EACE,kBAAA;AA/GF;AApfI;EAkmBJ;IAGI,kBAAA;EA7GF;AACF;AA+GI;EACE,mBAAA;AA7GN;AA5fI;EAwmBA;IAGI,mBAAA;EA3GN;AACF;AA4GM;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AA1GR;AAtgBI;EA6mBE;IAKI,mBAAA;EAxGR;AACF;AA0GM;EACE,4BAAA;AAxGR;AA9gBI;EAqnBE;IAGI,eAAA;EAtGR;AACF;AAwGM;EACE,6BAAA;AAtGR;AAthBI;EA2nBE;IAGI,eAAA;IACA,gBAAA;IACA,mBAAA;EApGR;AACF;AAsGM;EACE,4BAAA;EACA,mBAAA;AApGR;AAjiBI;EAmoBE;IAII,eAAA;EAlGR;AACF;AAsGI;EACE,kBAAA;AApGN;AAqGM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,4EAAA;AAnGR;AAljBI;EA8oBE;IAWI,WAAA;IACA,QAAA;EAnGR;AACF;AAsGM;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,wBAAA;EACA,WAAA;EACA,4BAAA;AApGR;AAqGQ;EACE,aAAA;AAnGV;AAnkBI;EA8pBE;IAWI,eAAA;IACA,iBAAA;IACA,kBAAA;IAEA,gBAAA;EAnGR;AACF;AAqGM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;AAnGR;AAoGQ;EACE,WAAA;AAlGV;AAuGI;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;AArGN;AAuGM;EACE,SAAA;AArGR;AAhmBI;EA6rBA;IAWI,8BAAA;EApGN;AACF;AAuGI;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AArGN;AAsGM;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;AApGR;AAwGI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;AAtGN;AArnBI;EAutBA;IAMI,kBAAA;EApGN;AACF;AAuGI;EAEE,8BAAA;AAtGN;AAuGM;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AArGR;AA0GI;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAxGN;AA2GI;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAzGN;AA9oBI;EAkvBA;IAQI,mBAAA;IACA,mBAAA;IACA,SAAA;EAxGN;AACF;AA0GM;EACE,eAAA;AAxGR;AAxpBI;EA+vBE;IAGI,4BAAA;IACA,aAAA;IACA,mBAAA;EAtGR;AACF;AAwGM;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAtGR;AAuGQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AArGV;AA/qBI;EAuwBE;IAiBI,SAAA;IACA,YAAA;EArGR;AACF;AAuGQ;EACE,eAAA;EACA,aAAA;AArGV;AAuGQ;EACE,eAAA;EACA,aAAA;AArGV;AA7rBI;EAgyBI;IAII,eAAA;EAnGV;AACF;AAqGQ;EACE,0BAAA;EACA,yBAAA;EACA,oBAAA;AAnGV;AAvsBI;EAuyBI;IAKI,eAAA;EAjGV;AACF;AAoGQ;EACE,uBAAA;EACA,cAAA;AAlGV;AAuGI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArGN;AAsGM;EACE,mBAAA;AApGR;AAqGQ;EACE,gBAAA;EACA,+BA10BC;EA20BD,eAAA;EACA,kBAAA;EACA,yBAAA;AAnGV;AAoGU;EACE,mBAAA;AAlGZ;AAsGM;EACE,mBAAA;EACA,YAAA;AApGR;AAwGE;EACE,kBAAA;EACA,iBAAA;AAtGJ;AAwGE;EACE,4BA71BI;EA81BJ,eAAA;EACA,gBAAA;AAtGJ;;AA0GA;EACE,8BAv2BQ;AAgwBV;;AA2GA;EACE,eAAA;EACA,gCAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EAGA,yBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AA1GF;AAjwBI;EA81BJ;IAiBI,aAAA;IACA,iBAAA;IACA,oBAAA;EA1GF;AACF;AApwBI;EA01BJ;IAuBI,iBAAA;IACA,oBAAA;EAzGF;AACF;AA2GE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EAuBA,sBAAA;EA4BA,gBAAA;AA1JJ;AA2GI;EACE,aAAA;EACA,gBAAA;AAzGN;AA4GI;EACE,kBAAA;AA1GN;AA6GI;EACE,qBAAA;EACA,YAAA;EACA,2BAAA;AA3GN;AA8GI;EACE,WAAA;AA5GN;AAgHI;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;AA9GN;AAiHI;EACE,WAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,yBAAA;AA/GN;AAkHI;EACE,8CAAA;AAhHN;AAmHI;EACE,UAAA;AAjHN;AAoHI;EACE,8CAAA;AAlHN;AAsHI;EACE;IACE,aAAA;EApHN;EAuHI;IACE,aAAA;IACA,sBAAA;IACA,WAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,uBAAA;IACA,0BAAA;EArHN;EAwHI;IACE,aAAA;IACA,UAAA;EAtHN;EAyHI;IACE,SAAA;IACA,kBAAA;IACA,eAAA;IACA,6BAAA;EAvHN;EA0HI;IACE,YAAA;EAxHN;AACF;AA8HI;EACE,qBAAA;EACA,0BAAA;EACA,2BAAA;EACA,YAAA;EACA,cAAA;EAyBA,qBAAA;AApJN;AAmIM;EACE,gBAAA;AAjIR;AAoIM;EACE,qBAAA;EACA,WAAA;AAlIR;AAr2BI;EAq+BE;IAKI,WAAA;EAjIR;AACF;AAt2BI;EAi+BE;IASI,WAAA;EAhIR;AACF;AA/2BI;EAo9BA;IAiCI,eAAA;EAlIN;AACF;AAh3BI;EAg9BA;IAqCI,eAAA;EAjIN;AACF;AAmII;EACE,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;AAjIN;AAmIM;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;AAjIR;AAqII;EACE,YAAA;EACA,WAAA;AAnIN;AAsII;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AApIN;AA94BI;EA+gCA;IAMI,kBAAA;IACA,WAAA;IACA,eAAA;IACA,WAAA;IACA,QAAA;IACA,MAAA;IACA,sBAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;EAnIN;EAqIM;IACE,OAAA;EAnIR;AACF;AAl6BI;EAmiCI;IAKI,kBAAA;EAlIV;AACF;AAv6BI;EA4iCI;IACE,cAAA;EAlIR;AACF;AA56BI;EA4iCI;IAII,cAAA;EAhIV;AACF;AA76BI;EA2gCA;IAuCI,WAAA;IACA,eAAA;IACA,WAAA;IACA,UAAA;IACA,MAAA;IACA,sBAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;EAjIN;EAqIM;IACE,OAAA;IACA,iBAAA;EAnIR;EAsIM;IACE,cAAA;EApIR;AACF;AAl8BI;EA0kCA;IAEI,cAAA;EAtIN;AACF;AAyIM;EACE,qBAAA;EACA,kBAAA;AAvIR;AAyIQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,OAAA;EAEA,8BAAA;EACA,oCAAA;AAxIV;AA2IQ;EACE,oBAAA;EACA,6BAAA;AAzIV;AA8II;EACE,eAAA;EAEA,4BAAA;EACA,kBAAA;AA7IN;AAn+BI;EA4mCA;IAOI,4BAAA;IACA,kBAAA;EA5IN;AACF;AA8IM;EAEE,cAAA;EAEA,iCAAA;AA9IR;AAkJI;EACE,aAAA;EACA,eAAA;EAEA,kBAAA;EACA,kBAAA;EACA,WAAA;AAjJN;AAmJM;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;EACA,uBAAA;AAjJR;AAmJQ;EACE,UAAA;AAjJV;AA3/BI;EAmoCE;IAaI,WAAA;EAjJR;AACF;AAmJQ;EACE,SAAA;AAjJV;AAvgCI;EA+nCA;IA8BI,cAAA;EAlJN;EAoJM;IACE,UAAA;IACA,4CAAA;EAlJR;EAqJM;IAEE,UAAA;EApJR;EAuJM;IACE,8CAAA;EArJR;AACF;AAlhCI;EA2nCA;IAgDI,cAAA;EArJN;EAuJM;IACE,UAAA;IACA,4CAAA;EArJR;EAwJM;IAEE,UAAA;EAvJR;EA0JM;IACE,8CAAA;EAxJR;AACF;;AA+JA;EACE,eAAA;EACA,iBAAA;EACA,yDAAA;EACA,qBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AA7JF;AAnjCI;EAosCJ;IAeI,sBAAA;IACA,eAAA;IACA,iBAAA;EA5JF;AACF;AA8JE;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;AA5JJ;AAlkCI;EAwtCF;IASI,YAAA;IACA,SAAA;IACA,QAAA;EA3JJ;AACF;AA8JE;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;AA5JJ;AAhlCI;EAuuCF;IAQI,8BAAA;IACA,SAAA;EA3JJ;AACF;AA6JI;EACE,8BAjwCI;EAkwCJ,eAAA;AA3JN;AA1lCI;EAmvCA;IAMI,iBAAA;EA3JN;AACF;AA8JI;EACE,6BA1wCG;EA2wCH,iBAAA;AA5JN;AAnmCI;EA6vCA;IAMI,eAAA;EA5JN;AACF;AAgKM;EACE,8BAtxCE;EAuxCF,gBAAA;AA9JR;AA5mCI;EAwwCE;IAKI,eAAA;EA7JR;AACF;AAiKI;EACE,SAAA;AA/JN;AAkKI;EACE,SAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AAhKN;AA1nCI;EAsxCA;IAOI,2BAAA;IACA,SAAA;EA/JN;AACF;AAiKM;EACE,8BA/yCE;EAgzCF,iBAAA;AA/JR;AApoCI;EAiyCE;IAKI,eAAA;EA9JR;AACF;;AAoKA;EAIE,uBAAA;EACA,mBAAA;AApKF;;AAwKA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,8FAAA;EACA,wBAAA;EACA,+BAAA;EACA,4BAAA;AAtKF;AAuKE;EACE,WAAA;AArKJ;AAsKI;EACE,iBAAA;EACA,oBAAA;AApKN;AAsKM;EAEE,kBAAA;AArKR;AAuKQ;EACE,gBAAA;EACA,+BAv1CC;EAw1CD,eAAA;EACA,mBAAA;AArKV;AAzqCI;EA00CI;IAMI,eAAA;IACA,cAAA;EAnKV;AACF;AAqKQ;EACE,8BAl2CA;EAm2CA,eAAA;AAnKV;AAnrCI;EAo1CI;IAII,eAAA;EAjKV;AACF;AAsKE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;AApKJ;AAuKE;EACE,kBAAA;EAGA,uBAAA;EACA,mBAAA;EACA,aAAA;EAGA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;AAzKJ;AAzsCI;EAq2CF;IAeI,gBAAA;IACA,aAAA;IACA,aAAA;EAvKJ;AACF;AAyKI;EACE,+BAr4CK;EAs4CL,kBAAA;EACA,eAAA;AAvKN;AArtCI;EAy3CA;IAKI,eAAA;EArKN;AACF;AAuKI;EACE,kBAAA;AArKN;AAsKM;EACE,kBAAA;EACA,eAAA;EACA,qBAAA;AApKR;AAluCI;EAm4CE;IAKI,eAAA;EAlKR;AACF;AAqKI;EACE,WAAA;EACA,8BA35CI;EA45CJ,YAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAnKN;AAhvCI;EA44CA;IASI,gBAAA;IACA,eAAA;EAjKN;AACF;AAmKI;EACE,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AAjKN;AAnwCI;EAy5CA;IAaI,gBAAA;IACA,eAAA;EA/JN;AACF;AAgKM;EACE,uBAAA;EACA,cAAA;AA9JR;AAiKI;EACE,gBAAA;EACA,kBAAA;AA/JN;AAjxCI;EA86CA;IAII,eAAA;EA7JN;AACF;AA+JM;EACE,qBAAA;EACA,eAAA;AA7JR;AA8JQ;EAEE,8BAAA;EACA,gBAAA;AA7JV;AAkKE;EACE,kBAAA;EACA,gBAAA;AAhKJ;;AAoKA;EACE,kBAAA;EACA,oBAAA;AAjKF;AAvyCI;EAs8CJ;IAII,kBAAA;EA/JF;AACF;AAgKE;EACE,+BAx9CO;EAy9CP,eAAA;EAIA,mBAAA;EACA,qBAAA;EACA,yBAAA;AAjKJ;AA4JI;EACE,kBAAA;AA1JN;AA+JI;EACE,WAAA;AA7JN;AAzzCI;EA48CF;IAcI,mBAAA;IACA,eAAA;EA7JJ;AACF;AA+JE;EACE,aAAA;EACA,SAAA;AA7JJ;AAn0CI;EA89CF;IAKI,sBAAA;EA5JJ;AACF;AA6JI;EACE,WAAA;AA3JN;AA4JM;EACE,8BAr/CE;EAs/CF,eAAA;EACA,mBAAA;AA1JR;AAh1CI;EAu+CE;IAKI,eAAA;IACA,mBAAA;EAxJR;AACF;AA0JM;EACE,eAAA;EACA,+BA7/CG;EA8/CH,mBAAA;AAxJR;AA31CI;EAg/CE;IAKI,eAAA;IACA,mBAAA;EAtJR;AACF;AAwJM;EACE,8BAvgDE;EAwgDF,eAAA;AAtJR;AAr2CI;EAy/CE;IAII,eAAA;EApJR;AACF;AAuJI;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EAEA,SAAA;AAtJN;AAwJM;EACE,gBAAA;AAtJR;AAwJM;EACE,WAAA;EACA,WAAA;EACA,uBAAA;AAtJR;AAwJM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAtJR;AAuJQ;EACE,eAAA;EAIA,gBAAA;AAxJV;AAl4CI;EAqhDI;IAGI,eAAA;EAlJV;AACF;AAoJU;EACE,WAAA;AAlJZ;AAqJQ;EACE,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAjjDA;EAkjDA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EAUA,gBAAA;AA5JV;AAt5CI;EA+hDI;IAWI,iBAAA;EAhJV;AACF;AAiJU;EACE,eAAA;AA/IZ;AA95CI;EA4iDM;IAGI,eAAA;EA7IZ;AACF;AAiJU;EACE,uBAAA;EACA,YAAA;AA/IZ;;AAuJA;EAEE,eAAA;EACA,yBAAA;AArJF;AA56CI;EA8jDJ;IAKI,eAAA;EAnJF;AACF;;AAqJA;EACE,eAAA;AAlJF;AAr7CI;EAskDJ;IAGI,eAAA;EAhJF;AACF;AAmJI;EACE,+BAzlDK;EA0lDL,eAAA;EACA,mBAAA;AAjJN;AA/7CI;EA6kDA;IAKI,eAAA;IACA,mBAAA;EA/IN;AACF;AAiJI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AA/IN;AAiJM;EACE,aAAA;EACA,WAAA;EAEA,mBAAA;EACA,gBAAA;EAKA,yBAAA;AApJR;AAn9CI;EA6lDE;IAOI,sBAAA;IACA,eAAA;EA7IR;AACF;AAgJM;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA9IR;AAj+CI;EAymDE;IAQI,eAAA;IACA,eAAA;EA5IR;AACF;;AAkJA;EACE,eAAA;AA/IF;AA3+CI;EAynDJ;IAII,eAAA;EA9IF;AACF;AAgJI;EACE,+BA5oDK;EA6oDL,eAAA;EACA,mBAAA;AA9IN;AAr/CI;EAgoDA;IAKI,eAAA;IACA,mBAAA;EA5IN;AACF;AA8II;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,8BAAA;EAEA,uBAAA;AA7IN;AApgDI;EAyoDA;IAUI,sBAAA;IACA,mBAAA;IACA,aAAA;IACA,SAAA;EA3IN;AACF;AA6IM;EACE,kBAAA;EACA,8BAAA;EA4BA,gBAAA;AAtKR;AA2IQ;EACE,eAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EAQA,gBAAA;AAhJV;AA0IU;EACE,8BAlrDF;AA0iDV;AA7hDI;EA4pDI;IAYI,eAAA;EAvIV;AACF;AAyIU;EACE,WAAA;AAvIZ;AA2IQ;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,qBAAA;AAzIV;AA4IQ;EACE,WAAA;AA1IV;AA6IM;EACE,iBAAA;EAEA,mBAAA;AA5IR;AA+IM;EACE,6BAAA;EAIA,gBAAA;AAhJR;AAvjDI;EAksDE;IAGI,eAAA;EA1IR;AACF;AA4IQ;EACE,WAAA;AA1IV;AA+IE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AA7IJ;AA+IE;EACE,yBAAA;EACA,0BAAA;EACA,eAAA;AA7IJ;AA8II;EACE,WAAA;AA5IN;AAgJI;EACE,mBAAA;AA9IN;AA3kDI;EA4tDF;IAEI,aAAA;IACA,yBAAA;IACA,WAAA;EA/IJ;AACF;;AAoJA;EACE,iBAAA;EACA,oBAAA;EACA,0DAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;AAjJF;AAmJI;EACE,eAAA;EACA,+BAnwDK;AAknDX;AAvmDI;EAsvDA;IAII,eAAA;EA/IN;AACF;AAiJI;EACE,kBAAA;EACA,gBAAA;AA/IN;AAhnDI;EA6vDA;IAII,eAAA;EA7IN;AACF;AA8IM;EACE,wBAAA;EACA,6BAAA;EACA,mBAAA;AA5IR;AA1nDI;EAmwDE;IAKI,sBAAA;EA1IR;AACF;AA4IQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,oBAAA;AA1IV;AAvoDI;EA2wDI;IAQI,SAAA;EAxIV;AACF;AAyIU;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EAEA,eAAA;AAxIZ;AAyIY;EACE,8BAzyDJ;EA0yDI,0BAAA;AAvId;AAyIY;EACE,4BA1yDN;EA2yDM,0BAAA;AAvId;AA1pDI;EAqxDM;IAeI,eAAA;EAtIZ;AACF;AAwIU;EACE,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,+BAvzDD;EAwzDC,eAAA;EACA,gBAAA;EACA,gBAAA;AAtIZ;AAuIY;EACE,uBAAA;EACA,YAAA;AArId;AA7qDI;EAuyDM;IAeI,eAAA;EArIZ;AACF;AAyIQ;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAvIV;AAyIU;EAEE,mBAAA;AAxIZ;AA4IM;;EAEE,2BAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;AA1IR;AA4IM;EACE,kBAAA;EACA,aAAA;EAEA,WAAA;AA3IR;AAvsDI;EA80DE;IAOI,UAAA;IACA,WAAA;IACA,WAAA;EA1IR;AACF;AA2IQ;EACE,YAAA;EACA,eAAA;EACA,eAAA;AAzIV;;AAgJA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AA7IF;AA+IE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,+CAAA;EACA,4CAAA;AA7IJ;AAgJE;EACE,QAAA;AA9IJ;AAgJE;EACE,QAAA;AA9IJ;;AAkJA;EACE;IACE,oBAAA;EA/IF;EAiJA;IACE,yBAAA;EA/IF;AACF;AAmJA;EACE,kBAAA;EACA,8FAAA;EACA,wBAAA;EACA,+BAAA;EACA,4BAAA;AAjJF;AAmJE;EACE,WAAA;AAjJJ;AAkJI;EAEE,oBAAA;AAjJN;AAmJM;EAEE,kBAAA;AAlJR;AAoJQ;EACE,gBAAA;EACA,+BAr6DC;EAs6DD,eAAA;EACA,mBAAA;AAlJV;AA1wDI;EAw5DI;IAMI,eAAA;IACA,cAAA;EAhJV;AACF;AAkJQ;EACE,8BAh7DA;EAi7DA,eAAA;AAhJV;AApxDI;EAk6DI;IAII,eAAA;EA9IV;AACF;AAmJE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;AAjJJ;AAoJE;EACE,kBAAA;EAGA,uBAAA;EACA,mBAAA;EACA,aAAA;EAGA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;AAtJJ;AA1yDI;EAm7DF;IAeI,gBAAA;IACA,aAAA;IACA,aAAA;EApJJ;AACF;AAsJI;EACE,+BAn9DK;EAo9DL,kBAAA;EACA,eAAA;AApJN;AAtzDI;EAu8DA;IAKI,eAAA;EAlJN;AACF;AAoJI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AAlJN;AAoJI;EACE,kBAAA;AAlJN;AAmJM;EACE,kBAAA;EACA,eAAA;EACA,qBAAA;AAjJR;AAx0DI;EAs9DE;IAKI,eAAA;EA/IR;AACF;AAkJI;EACE,WAAA;EACA,8BA9+DI;EA++DJ,YAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAhJN;AAt1DI;EA+9DA;IASI,gBAAA;IACA,eAAA;EA9IN;AACF;AAgJI;EACE,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AA9IN;AAz2DI;EA4+DA;IAaI,gBAAA;IACA,eAAA;EA5IN;AACF;AA6IM;EACE,uBAAA;EACA,cAAA;AA3IR;AA8II;EACE,gBAAA;EACA,kBAAA;AA5IN;AAv3DI;EAigEA;IAII,eAAA;EA1IN;AACF;AA4IM;EACE,qBAAA;EACA,eAAA;AA1IR;AA2IQ;EAEE,8BAAA;EACA,gBAAA;AA1IV;AA+IE;EACE,kBAAA;EACA,gBAAA;AA7IJ;;AAiJA;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EA5gEA,aAAA;EA8gEA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AA1IF;AA2IE;EAlhEA,aAAA;EAohEE,sBAAA;EACA,mBAAA;EACA,uBAAA;AArIJ;AAsII;EACE,eAAA;EACA,+BAvjEK;EAwjEL,mBAAA;AApIN;AAsII;EACE,eAAA;EACA,6BA7jEG;AAy7DT;AAuIE;EACE,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;AArIJ;AAsII;EACE,iBAAA;EACA,YAAA;AApIN","sourcesContent":["//\n@font-face {\n  font-family: \"poppins Light\";\n  src: url(\"../fonts/Poppins-Light.woff2\") format(\"woff2\"),\n    url(\"../fonts/Poppins-Light.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"poppins Regular\";\n  src: url(\"../fonts/Poppins-Regular.woff2\") format(\"woff2\"),\n    url(\"../fonts/Poppins-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"poppins Medium\";\n  src: url(\"../fonts/Poppins-Medium.woff2\") format(\"woff2\"),\n    url(\"../fonts/Poppins-Medium.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"poppins Semibold\";\n  src: url(\"../fonts/Poppins-SemiBold.woff2\") format(\"woff2\"),\n    url(\"../fonts/Poppins-SemiBold.woff\") format(\"woff\");\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n/*VARIABLES*/\n\n$regular: \"poppins Regular\";\n$medium: \"poppins Medium\";\n$semibold: \"poppins Semibold\";\n$light: \"poppins Light\";\n\n/* MIXINS */\n\n@mixin mq($size) {\n  @if $size==xs {\n    @media (min-width: 320px) {\n      @content;\n    }\n  } @else if $size==mobile {\n    @media (max-width: 767px) {\n      @content;\n    }\n  } @else if $size==tab {\n    @media only screen and (min-width: 768px) and (max-width: 1024px) {\n      @content;\n    }\n  } @else if $size==desktop {\n    @media only screen and (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin flexbox {\n  display: -webkit-box; // old\n  display: -moz-box; // old\n  display: -ms-flexbox; // ie\n  display: -webkit-flex; // new\n  display: flex; // new\n}\n\n@mixin opacity($opacity) {\n  opacity: $opacity;\n  $opacity-ie: $opacity * 100;\n  filter: alpha(opacity=$opacity-ie); //IE8\n}\n\n@mixin input-placeholder {\n  &.placeholder {\n    @content;\n  }\n\n  &:-moz-placeholder {\n    @content;\n  }\n\n  &::-moz-placeholder {\n    @content;\n  }\n\n  &:-ms-input-placeholder {\n    @content;\n  }\n\n  &::-webkit-input-placeholder {\n    @content;\n  }\n}\n\n/* RESET CSS */\n\n/* http://meyerweb.com/eric/tools/css/reset/\n  v2.0 | 20110126\n  License: none (public domain)\n  */\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  color: inherit;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n\n// broser\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  line-height: 1;\n  //like\n  overflow: scroll;\n  overflow-x: hidden;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n* {\n  box-sizing: border-box;\n}\n\na {\n  &,\n  &:hover,\n  &:active,\n  &:visited,\n  &:focus {\n    color: inherit;\n  }\n\n  text-decoration: none;\n}\n\ni,\nem,\n.italic-text {\n  font-style: italic;\n}\n\nb,\nstrong,\nth,\n.bold-text {\n  //font-weight: bold;\n}\n\n.left {\n  float: left;\n}\n\n.right {\n  float: right;\n}\n\n.wrap-clear::after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n\n.clearfix {\n  zoom: 1;\n  display: table;\n  clear: both;\n\n  &:before,\n  &:after {\n    content: \"\";\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n}\n\n:focus {\n  outline: none;\n}\n\ninput,\nbutton,\ntextarea {\n  border-radius: 0;\n  appearance: none;\n}\n\nselect {\n  border-radius: 0;\n  background-color: white;\n}\n\ntextarea {\n  resize: none;\n}\n\n/* COMMONS */\n\nbody {\n  -webkit-font-smoothing: antialiased;\n  letter-spacing: 0.6px;\n  -webkit-user-select: none;\n}\n\nol,\nul {\n  margin: 0px;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  -webkit-appearance: none;\n  outline: none;\n  border-radius: 0;\n  background-color: transparent;\n}\n\ninput,\ntextarea {\n  background: transparent;\n  border: none;\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus,\nbutton:focus,\na:focus {\n  outline: none;\n}\n\na {\n  color: inherit;\n  cursor: pointer;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\nh1,\nh2,\nh3,\nh4 {\n  line-height: 1.2;\n}\n\np {\n  line-height: 1.4;\n}\n\nimg {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.slick-next:before,\n.slick-prev:before {\n  content: \"\";\n}\n\n.scroll-lock {\n  height: 100%;\n  overflow-y: hidden;\n\n  @include mq(mobile) {\n    // overflow-y: visible;\n  }\n}\n\nsmall {\n  font-size: 13px;\n}\n\n.input[type=\"checkbox\"] {\n  -webkit-appearance: checkbox;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n.hidden-lg {\n  @include mq(desktop) {\n    display: none !important;\n  }\n}\n\n.hidden-xs {\n  @include mq(mobile) {\n    display: none !important;\n  }\n}\n\n.hidden-md {\n  @include mq(tab) {\n    display: none !important;\n  }\n}\n\n.img-responsive {\n  width: 100%;\n  height: auto;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 90%;\n\n  @include mq(tab) {\n    width: 90%;\n    max-width: 768px;\n  }\n\n  @include mq(mobile) {\n    width: 100%;\n    margin: 0 auto;\n    padding: 0 15px;\n  }\n}\n\nbody {\n  font-family: $light;\n}\n\n.tabs {\n  margin-top: 20px;\n  font-family: $light;\n  @include mq(mobile) {\n    margin-top: 10px;\n  }\n}\n\n.tab-buttons {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.tab-buttons button {\n  padding: 10px 20px;\n  margin: 0 5px;\n  border: none;\n  cursor: pointer;\n  background-color: #f0f0f0;\n  transition: background-color 0.3s;\n}\n\n.tab-buttons button.active {\n  background-color: #007bff;\n  color: white;\n}\n\n.tab-buttons button:hover {\n  background-color: #e0e0e0;\n}\n\n.tab-content {\n  padding: 20px;\n  border: 1px solid #f0f0f0;\n  background-color: #fafafa;\n}\n\n.wrapper-tabs {\n  // padding: 0 20px;\n}\n\n.accordion-wrapper {\n  &:not(:last-of-type) {\n    border-bottom: 1px solid;\n  }\n  & + * {\n    margin-top: 0.5em;\n  }\n}\n\n.accordion-item {\n  overflow: hidden;\n  transition: max-height 0.3s cubic-bezier(1, 0, 1, 0);\n  height: auto;\n  max-height: 9999px;\n}\n\n.accordion-item.collapsed {\n  max-height: 0;\n  transition: max-height 0.35s cubic-bezier(0, 1, 0, 1);\n}\n\n.accordion-title {\n  font-family: $regular;\n  font-weight: 600;\n  cursor: pointer;\n  color: #666;\n  padding: 20px 0;\n  padding-bottom: 15px;\n  // border: solid 1px #ccc;\n  border-radius: 1.5em;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.3s ease;\n  position: relative;\n  // border: 1px solid black;\n\n  span {\n    font-size: 26px;\n    @include mq(mobile) {\n      font-size: 18px;\n    }\n  }\n\n  svg {\n    position: absolute;\n    top: 20px;\n    right: 0px;\n    font-size: 20px;\n  }\n\n  &::after {\n    // content: \"+\";\n    //font-size: 26px;\n  }\n\n  &:hover,\n  &.open {\n    color: black;\n  }\n\n  &.open {\n    &::after {\n      //  content: \"-\";\n    }\n    // span {\n    //   border: 1px solid black;\n    //   border-radius: 30px;\n    //   padding: 10px 20px;\n    // }\n  }\n}\n\n.accordion-content {\n  padding: 1em 10px;\n  padding-top: 0px;\n  font-family: $regular;\n  line-height: 1.4;\n  font-size: 20px;\n  @include mq(mobile) {\n    font-size: 16px;\n  }\n}\n.react-tabs__tab {\n  background-color: #fedeff;\n  border-radius: 30px;\n  padding: 10px 35px;\n  font: 18px $semibold;\n  text-transform: uppercase;\n\n  width: 260px;\n  text-align: center;\n  @include mq(mobile) {\n    padding: 5px 25px;\n    font-size: 14px;\n    width: 160px;\n  }\n\n  &:hover {\n    border: 1px solid black;\n    box-shadow: 2px 2px black;\n    transition: 0.3s;\n  }\n}\n\n.react-tabs__tab--selected {\n  background: #fddefe;\n  border: 1px solid black;\n  font-family: $semibold;\n  border-radius: 30px;\n  box-shadow: 2px 2px black;\n  &:focus {\n    outline: unset;\n  }\n}\n.react-tabs__tab:focus:after {\n  content: \"\";\n  position: unset;\n  height: 0;\n  left: unset;\n  right: unset;\n  bottom: unset;\n  background: transparent;\n}\n.react-tabs__tab-list {\n  margin: 0;\n  border: none;\n  margin-bottom: 30px;\n  display: flex;\n  justify-content: space-between;\n  @include mq(mobile) {\n    gap: 10px;\n    justify-content: center;\n    flex-wrap: wrap;\n    .react-tabs__tab{\n      flex-basis: 48%;\n    }\n  }\n}\n.react-tabs__tab-panel--selected {\n  background: #fddefe;\n  padding: 20px;\n  border: 1px solid black;\n  border-radius: 20px;\n  &:focus {\n    border: none;\n    padding: 0;\n  }\n}\n\n.agency-partner-section {\n  padding-top: 180px;\n  @include mq(mobile) {\n    padding-top: 120px;\n  }\n  .agps-wrapper {\n    .search-component {\n      margin-bottom: 40px;\n      @include mq(mobile) {\n        margin-bottom: 20px;\n      }\n      .max-width-11 {\n        max-width: 1100px;\n        margin-left: auto;\n        margin-right: auto;\n        @include mq(mobile) {\n          margin-bottom: 10px;\n        }\n      }\n      h1 {\n        font: 30px $regular;\n        @include mq(mobile) {\n          font-size: 23px;\n        }\n      }\n      h3 {\n        font: 50px $semibold;\n        @include mq(mobile) {\n          font-size: 24px;\n          line-height: 1.1;\n          margin-bottom: 10px;\n        }\n      }\n      p {\n        font: 20px $regular;\n        margin-bottom: 60px;\n        @include mq(mobile) {\n          font-size: 14px;\n        }\n      }\n    }\n\n    .search-label {\n      position: relative;\n      &::before {\n        content: \"\";\n        position: absolute;\n        left: 5px;\n        top: 0;\n        bottom: 0;\n        width: 20px;\n        background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill-rule='evenodd'%3E%3Cpath d='M16.036 18.455l2.404-2.405 5.586 5.587-2.404 2.404zM8.5 2C12.1 2 15 4.9 15 8.5S12.1 15 8.5 15 2 12.1 2 8.5 4.9 2 8.5 2zm0-2C3.8 0 0 3.8 0 8.5S3.8 17 8.5 17 17 13.2 17 8.5 13.2 0 8.5 0zM15 16a1 1 0 1 1 2 0 1 1 0 1 1-2 0'%3E%3C/path%3E%3C/svg%3E\")\n          center / contain no-repeat;\n\n        @include mq(mobile) {\n          width: 14px;\n          top: 5px;\n        }\n      }\n\n      input {\n        padding: 8px 10px;\n        padding-left: 35px;\n        border: none;\n        border-bottom: 1px solid;\n        width: 100%;\n        font: 20px $regular;\n        &:focus {\n          outline: none;\n        }\n        @include mq(mobile) {\n          font-size: 14px;\n          padding: 5px 10px;\n          padding-left: 25px;\n\n          margin-top: 10px;\n        }\n      }\n      svg.fa-xmark {\n        position: absolute;\n        right: 0px;\n        top: 0px;\n        transition: all 0.2s ease;\n        cursor: pointer;\n        padding: 8px 10px;\n        &:hover {\n          color: gray;\n        }\n      }\n    }\n\n    .filter-wrap {\n      display: flex;\n      align-items: flex-start;\n      flex-direction: column;\n      align-items: stretch;\n      gap: 20px;\n\n      .tabs {\n        flex: 1;\n      }\n      @include mq(mobile){\n        flex-direction: column-reverse;\n      }\n    }\n\n    .apply-filters {\n      border: 1px solid;\n      padding: 4px 8px;\n      border-radius: 5px;\n      &:hover {\n        background-color: black;\n        color: white;\n        transition: 0.3s;\n      }\n    }\n\n    .filter-actions {\n      display: flex;\n      align-items: center;\n      gap: 20px;\n      align-self: flex-end;\n      @include mq(mobile) {\n        align-self: center;\n      }\n    }\n\n    .clear-filters {\n      // text-decoration: underline;\n      border-bottom: 1px solid black;\n      &:hover {\n        font-weight: 900;\n        transition: 0.3s;\n        transition: 0.3s;\n        // font-family: $medium;\n      }\n    }\n\n    .agency-container {\n      max-width: 1200px;\n      padding: 0 15px;\n      margin: 0 auto;\n    }\n\n    .agency-results {\n      display: flex;\n      gap: 40px;\n      flex-wrap: wrap;\n      padding-top: 40px;\n      padding-bottom: 40px;\n\n      @include mq(mobile) {\n        align-items: center;\n        flex-direction: row;\n        gap: 20px;\n      }\n     \n      .view-link {\n        flex-basis: 30%;\n        @include mq(mobile) {\n          flex-basis: calc(50% - 10px);\n          display: flex;\n          align-items: center;\n        }\n      }\n      .agency-wrapper {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n        min-height: 10rem;\n        padding: 1rem 1.375rem;\n        background-color: #fddefe;\n        border-radius: 10px;\n        border: 2px solid black;\n        transition: 0.3s;\n        .adress-wrapper {\n          display: flex;\n          flex-direction: column;\n          gap: 5px;\n        }\n\n        @include mq(mobile) {\n          gap: 10px;\n          flex-grow: 1;\n        }\n\n        h3 {\n          font-size: 20px;\n          margin-top: 0;\n        }\n        p {\n          font-size: 16px;\n          margin-top: 0;\n          @include mq(mobile) {\n            font-size: 14px;\n          }\n        }\n        div.view-copy {\n          text-decoration: underline;\n          text-transform: uppercase;\n          align-self: flex-end;\n          @include mq(mobile) {\n            font-size: 14px;\n          }\n        }\n\n        &:hover {\n          background-color: black;\n          color: #fddefe;\n        }\n      }\n    }\n\n    .tablist-wrap {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      li {\n        margin-bottom: 10px;\n        a {\n          padding: 4px 6px;\n          font-family: $semibold;\n          font-size: 16px;\n          border-radius: 5px;\n          transition: all 0.3s ease;\n          &:hover {\n            background: #d8d8d8;\n          }\n        }\n      }\n      li.active a {\n        background: #000000;\n        color: white;\n      }\n    }\n  }\n  .search-results {\n    position: relative;\n    min-height: 200px;\n  }\n  .empty-results {\n    font-family: $light;\n    font-size: 20px;\n    margin-top: 40px;\n  }\n}\n\n.login-page {\n  font-family: $regular;\n}\n\n//\nheader {\n  position: fixed;\n  transition: top 0.6s ease-in-out;\n  left: 0;\n  right: 0;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  z-index: 5000;\n  // background-color: #11173e;\n  // background-image: url(\"../images/banner/bg-nva.png\");\n  background-color: #fedfff;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n\n  @include mq(mobile) {\n    // background-image: url(\"../images/banner/bg100.png\");\n    z-index: 5000;\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  @include mq(tab) {\n    padding-top: 15px;\n    padding-bottom: 10px;\n  }\n\n  .header-main {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    //\n    //\n    .nav-menu {\n      display: flex;\n      list-style: none;\n    }\n\n    .nav-item {\n      margin-right: 20px;\n    }\n\n    .nav-link {\n      text-decoration: none;\n      color: black;\n      transition: color 0.3s ease;\n    }\n\n    .nav-link:hover {\n      color: grey;\n    }\n\n    /* Hamburger Styling */\n    .hamburger {\n      display: none;\n      cursor: pointer;\n      flex-direction: column;\n      align-items: center;\n    }\n\n    .hamburger .bar {\n      width: 25px;\n      height: 2px;\n      background-color: black;\n      margin: 3px 0;\n      transition: all 0.3s ease;\n    }\n\n    .hamburger.active .bar:nth-child(1) {\n      transform: rotate(-45deg) translate(-5px, 6px);\n    }\n\n    .hamburger.active .bar:nth-child(2) {\n      opacity: 0;\n    }\n\n    .hamburger.active .bar:nth-child(3) {\n      transform: rotate(45deg) translate(-5px, -6px);\n    }\n\n    /* Mobile Menu */\n    @media (max-width: 768px) {\n      .hamburger {\n        display: flex;\n      }\n\n      .nav-menu {\n        display: none;\n        flex-direction: column;\n        width: 100%;\n        position: absolute;\n        top: 60px;\n        left: 0;\n        background-color: white;\n        border-top: 1px solid #ddd;\n      }\n\n      .nav-menu.active {\n        display: flex;\n        z-index: 1;\n      }\n\n      .nav-item {\n        margin: 0;\n        text-align: center;\n        padding: 15px 0;\n        border-bottom: 1px solid #ddd;\n      }\n\n      .nav-link {\n        color: black;\n      }\n    }\n\n    //\n    //\n\n    a {\n      display: inline-block;\n      text-transform: capitalize;\n      font: 18px $medium;\n      color: black;\n      display: block;\n\n      &:hover {\n        // text-decoration: underline;\n        // transition: 0.7s ease;\n        // color: #9768aa;\n      }\n\n      #logo-brand {\n        transition: 0.6s;\n      }\n\n      img {\n        display: inline-block;\n        width: 83px;\n\n        @include mq(mobile) {\n          width: 70px;\n        }\n\n        @include mq(tab) {\n          width: 61px;\n        }\n      }\n\n      display: inline-block;\n\n      @include mq(mobile) {\n        font-size: 20px;\n      }\n\n      @include mq(tab) {\n        font-size: 24px;\n      }\n    }\n    .logout-btn {\n      border: 1px solid black;\n      padding: 5px 15px;\n      border-radius: 20px;\n      cursor: pointer;\n      font: 16px $regular;\n\n      &:hover {\n        background-color: black;\n        color: #fedeff;\n        transition: all 0.3s ease;\n      }\n    }\n\n    .brand {\n      font-size: 0;\n      z-index: 10;\n    }\n\n    .nav-menu {\n      display: flex;\n      align-items: center;\n      gap: 2.5rem;\n\n      @include mq(mobile) {\n        padding-top: 100px;\n        z-index: -1;\n        position: fixed;\n        left: -100%;\n        top: 0px;\n        gap: 0;\n        flex-direction: column;\n        width: 100%;\n        min-height: 100vh;\n        text-align: center;\n        transition: 0.3s;\n        overflow: hidden;\n        background-color: #f8dffd;\n\n        &.active {\n          left: 0;\n\n          // overflow: hidden;\n          @include mq(mobile) {\n            padding-top: 100px;\n          }\n        }\n\n        .nav-item {\n          margin: 16px 0;\n\n          @include mq(mobile) {\n            margin: 10px 0;\n          }\n        }\n      }\n\n      @include mq(tab) {\n        z-index: -1;\n        position: fixed;\n        left: -100%;\n        top: 100px;\n        gap: 0;\n        flex-direction: column;\n        width: 100%;\n        min-height: 100vh;\n        text-align: center;\n        transition: 0.3s;\n\n        // @extend.common-bg;\n\n        &.active {\n          left: 0;\n          padding-top: 3rem;\n        }\n\n        .nav-item {\n          margin: 10px 0;\n        }\n      }\n    }\n\n    .nav-item {\n      @include mq(tab) {\n        line-height: 2;\n        // font-size: 24px;\n      }\n\n      .nav-link {\n        display: inline-block;\n        position: relative;\n\n        &:after {\n          content: \"\";\n          position: absolute;\n          width: 100%;\n          transform: scaleX(0);\n          height: 2px;\n          bottom: -18px;\n          left: 0;\n          // background-color: $orange;\n          transform-origin: bottom right;\n          transition: transform 0.25s ease-out;\n        }\n\n        &:hover::after {\n          transform: scaleX(1);\n          transform-origin: bottom left;\n        }\n      }\n    }\n\n    .join-now {\n      font-size: 18px;\n      // border: 2px solid #ff6d00;\n      border-radius: 25px 0 25px 0;\n      padding: 15px 40px;\n\n      @include mq(mobile) {\n        border-radius: 20px 0 20px 0;\n        padding: 10px 20px;\n      }\n\n      &:hover {\n        // background-color: $orange;\n        color: #11173e;\n        // border: 2px solid #11173e;\n        transition: all 0.35s ease-in-out;\n      }\n    }\n\n    .hamburger {\n      display: none;\n      cursor: pointer;\n      // border: 1px solid black;\n      border-radius: 50%;\n      padding: 13px 15px;\n      z-index: 10;\n\n      .bar {\n        display: block;\n        width: 20px;\n        height: 3px;\n        margin: 5px auto;\n        transition: all 0.3s ease-in-out;\n        background-color: black;\n\n        &:nth-child(1) {\n          opacity: 0;\n        }\n\n        @include mq(tab) {\n          width: 35px;\n        }\n\n        &.bar-1 {\n          margin: 0;\n        }\n      }\n\n      @include mq(mobile) {\n        display: block;\n\n        &.active .bar:nth-child(1) {\n          opacity: 1;\n          transform: translate(0px, 8px) rotate(45deg);\n        }\n\n        &.active .bar:nth-child(2) {\n          // transform: translate(0px, 8px) rotate(45deg);\n          opacity: 0;\n        }\n\n        &.active .bar:nth-child(3) {\n          transform: translate(0px, -8px) rotate(-45deg);\n        }\n      }\n\n      @include mq(tab) {\n        display: block;\n\n        &.active .bar:nth-child(1) {\n          opacity: 1;\n          transform: translate(0px, 8px) rotate(45deg);\n        }\n\n        &.active .bar:nth-child(2) {\n          // transform: translate(0px, 8px) rotate(45deg);\n          opacity: 0;\n        }\n\n        &.active .bar:nth-child(3) {\n          transform: translate(0px, -8px) rotate(-45deg);\n        }\n      }\n    }\n  }\n}\n\n// footer\nfooter {\n  padding: 4rem 0;\n  padding-top: 6rem;\n  background-image: url(\"../images/04/Rectangle1.png\");\n  background-size: 100%;\n  background-repeat: no-repeat;\n  position: relative;\n  overflow: hidden;\n  // position: fixed;\n  overflow: hidden;\n  left: 0;\n  bottom: 0;\n  right: 0;\n\n  @include mq(mobile) {\n    background-size: cover;\n    padding: 2rem 0;\n    padding-top: 6rem;\n  }\n\n  .footer-bg-shape {\n    position: absolute;\n    position: absolute;\n    bottom: -54%;\n    right: 10%;\n    width: 500px;\n    z-index: 1;\n\n    @include mq(mobile) {\n      width: 240px;\n      bottom: 0;\n      left: 0%;\n    }\n  }\n\n  .footer-wrapper {\n    position: relative;\n    z-index: 10;\n    padding-top: 2rem;\n    display: flex;\n    justify-content: space-between;\n\n    @include mq(mobile) {\n      flex-direction: column-reverse;\n      gap: 1rem;\n    }\n\n    h3 {\n      font-family: $regular;\n      font-size: 2rem;\n\n      // max-width: 70%;\n      @include mq(mobile) {\n        font-size: 1.1rem;\n      }\n    }\n\n    h4 {\n      font-family: $medium;\n      font-size: 1.2rem;\n\n      // max-width: 70%;\n      @include mq(mobile) {\n        font-size: 14px;\n\n        // font-size: 1rem;\n      }\n\n      &.email-id {\n        font-family: $regular;\n        margin-top: 1rem;\n\n        @include mq(mobile) {\n          margin-top: 5px;\n        }\n      }\n    }\n\n    .wrapper-item {\n      flex: 1;\n    }\n\n    .wrapper-item-1 {\n      flex: 1;\n      display: flex;\n      justify-content: flex-end;\n      gap: 2rem;\n\n      @include mq(mobile) {\n        justify-content: flex-start;\n        gap: 1rem;\n      }\n\n      li {\n        font-family: $regular;\n        font-size: 1.4rem;\n\n        @include mq(mobile) {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n}\n\nmain {\n  // min-height: 100vh;\n  // padding-top: 100px;\n  // display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n//\n.login-page {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: url(\"../images/01/dots.png\"), url(\"../images/01/login-head.png\");\n  background-position: top;\n  background-size: 100%, 100% 55%;\n  background-repeat: no-repeat;\n  .wrapper-login {\n    width: 100%;\n    .hero-section {\n      padding-top: 99px;\n      padding-bottom: 40px;\n\n      .hero-copy {\n        // background-color: #fedeff;\n        text-align: center;\n\n        h2 {\n          margin-top: 20px;\n          font-family: $semibold;\n          font-size: 60px;\n          margin-bottom: 20px;\n          @include mq(mobile) {\n            font-size: 26px;\n            margin: 10px 0;\n          }\n        }\n        p {\n          font-family: $regular;\n          font-size: 24px;\n          @include mq(mobile) {\n            font-size: 16px;\n          }\n        }\n      }\n    }\n  }\n  .back-shape {\n    position: absolute;\n    right: 450px;\n    top: 350px;\n    width: 300px;\n    // z-index: 5;\n  }\n  .form-wrapper {\n    position: relative;\n    // z-index: 10;\n    // padding-top: 100px;\n    border: 1px solid black;\n    border-radius: 20px;\n    padding: 35px;\n    // padding-top: 40px;\n    // padding-bottom: 40px;\n    max-width: 500px;\n    height: 450px;\n    margin-bottom: 60px;\n    box-shadow: 8px 8px black;\n    background-color: white;\n    @include mq(mobile) {\n      max-width: 325px;\n      padding: 25px;\n      height: 360px;\n    }\n\n    .login-copy {\n      font-family: $semibold;\n      text-align: center;\n      font-size: 34px;\n      @include mq(mobile) {\n        font-size: 24px;\n      }\n    }\n    .err-inpt-wrap {\n      position: relative;\n      .err-div {\n        position: absolute;\n        font-size: 12px;\n        color: rgb(255, 0, 0);\n        @include mq(mobile) {\n          font-size: 14px;\n        }\n      }\n    }\n    .input-field {\n      width: 100%;\n      font-family: $regular;\n      color: black;\n      font-size: 20px;\n      border-bottom: 1px solid black;\n      margin-bottom: 10px;\n      margin-top: 40px;\n      @include mq(mobile) {\n        margin-top: 30px;\n        font-size: 16px;\n      }\n    }\n    .btn {\n      margin-top: 40px;\n      width: 100%;\n      border: 1px solid black;\n      outline: none;\n      padding: 10px 20px;\n      font-size: 24px;\n      background-color: #fedeff;\n      border-radius: 10px;\n      box-shadow: 2px 2px black;\n      transition: 0.3s;\n      cursor: pointer;\n      @include mq(mobile) {\n        margin-top: 30px;\n        font-size: 16px;\n      }\n      &:hover {\n        background-color: black;\n        color: #fedeff;\n      }\n    }\n    .forgot-copy {\n      margin-top: 20px;\n      text-align: center;\n      @include mq(mobile) {\n        font-size: 13px;\n      }\n\n      span {\n        display: inline-block;\n        cursor: pointer;\n        &:hover {\n          // text-decoration: underline;\n          border-bottom: 1px solid black;\n          transition: 0.1s;\n        }\n      }\n    }\n  }\n  .login-footer {\n    position: relative;\n    min-height: 90px;\n  }\n}\n\n.agency-wrapper {\n  padding-top: 180px;\n  padding-bottom: 50px;\n  @include mq(mobile) {\n    padding-top: 120px;\n  }\n  .back-search {\n    font-family: $semibold;\n    font-size: 30px;\n    span {\n      margin-right: 20px;\n    }\n    margin-bottom: 40px;\n    display: inline-block;\n    transition: all 0.3s ease;\n    &:hover {\n      color: gray;\n    }\n\n    @include mq(mobile) {\n      margin-bottom: 30px;\n      font-size: 18px;\n    }\n  }\n  .banner-wrapper {\n    display: flex;\n    gap: 40px;\n\n    @include mq(mobile) {\n      flex-direction: column;\n    }\n    .flex-copy {\n      flex: 1.3;\n      h3 {\n        font-family: $regular;\n        font-size: 30px;\n        margin-bottom: 10px;\n        @include mq(mobile) {\n          font-size: 20px;\n          margin-bottom: 10px;\n        }\n      }\n      h4 {\n        font-size: 70px;\n        font-family: $semibold;\n        margin-bottom: 20px;\n        @include mq(mobile) {\n          font-size: 32px;\n          margin-bottom: 10px;\n        }\n      }\n      p {\n        font-family: $regular;\n        font-size: 20px;\n        @include mq(mobile) {\n          font-size: 16px;\n        }\n      }\n    }\n    .flex-logo {\n      flex: 1;\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n      // border-top: 1px solid black;\n      gap: 2rem;\n\n      img {\n        max-width: 240px;\n      }\n      .center-line {\n        width: 100%;\n        height: 1px;\n        background-color: black;\n      }\n      .social-link-wrapper {\n        display: flex;\n        align-items: center;\n        gap: 20px;\n        .icon-link {\n          font-size: 30px;\n          @include mq(mobile) {\n            font-size: 25px;\n          }\n          transition: 0.3s;\n          &:hover {\n            color: #666;\n          }\n        }\n        .visit-link {\n          border: 1px solid black;\n          padding: 10px 30px;\n          border-radius: 30px;\n          font-size: 30px;\n          font-family: $regular;\n          display: inline-block;\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          @include mq(mobile) {\n            padding: 7px 12px;\n          }\n          span {\n            font-size: 16px;\n            @include mq(mobile) {\n              font-size: 14px;\n            }\n          }\n          transition: 0.3s;\n\n          &:hover {\n            background-color: black;\n            color: white;\n          }\n        }\n      }\n    }\n  }\n}\n\n.acc-wrapper-section {\n  // padding: 50px;\n  padding: 50px 0;\n  background-color: #fedeff;\n  @include mq(mobile) {\n    padding: 40px 0;\n  }\n}\n.department-section {\n  padding: 50px 0;\n  @include mq(mobile) {\n    padding: 40px 0;\n  }\n\n  .department-wrapper {\n    .heading-dpt {\n      font-family: $semibold;\n      font-size: 40px;\n      margin-bottom: 50px;\n      @include mq(mobile) {\n        font-size: 24px;\n        margin-bottom: 20px;\n      }\n    }\n    .flex-card {\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n      align-items: center;\n      justify-content: center;\n\n      .flex-1 {\n        display: flex;\n        width: 100%;\n        // flex: 1;\n        border-radius: 10px;\n        overflow: hidden;\n        @include mq(mobile) {\n          flex-direction: column;\n          padding: 20px 0;\n        }\n        background-color: #fedeff;\n      }\n      .card-item {\n        flex: 1 0 28%;\n        padding: 30px 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        text-align: center;\n        @include mq(mobile) {\n          padding: 10px 0;\n          font-size: 16px;\n        }\n      }\n    }\n  }\n}\n//\n.agency-clients-section {\n  padding: 50px 0;\n\n  @include mq(mobile) {\n    padding: 40px 0;\n  }\n  .agency-clients-wrapper {\n    .heading-agcy {\n      font-family: $semibold;\n      font-size: 40px;\n      margin-bottom: 50px;\n      @include mq(mobile) {\n        font-size: 24px;\n        margin-bottom: 20px;\n      }\n    }\n    .client-filters {\n      display: flex;\n      align-items: center;\n      border-radius: 10px;\n      padding: 40px 20px;\n      background-color: #fedeff;\n      justify-content: space-between;\n\n      border: black 1px solid;\n      @include mq(mobile) {\n        flex-direction: column;\n        align-items: center;\n        padding: 20px;\n        gap: 20px;\n      }\n\n      .select-wrapper {\n        position: relative;\n        border-bottom: 1px solid black;\n        select {\n          cursor: pointer;\n          border: none;\n          font: 22px $semibold;\n          padding-right: 35px;\n          position: relative;\n          z-index: 200;\n\n          option {\n            font-family: $regular;\n          }\n          @include mq(mobile) {\n            font-size: 18px;\n          }\n          transition: 0.3s;\n          &:hover {\n            color: #666;\n          }\n        }\n\n        .fevicon-arrow {\n          position: absolute;\n          right: 8px;\n          top: 50%;\n          transform: translateY(-50%);\n          display: inline-block;\n        }\n        transition: 0.3s;\n        &:hover {\n          color: #666;\n        }\n      }\n      .select-wrap {\n        padding: 5px 10px;\n        // display: flex;\n        align-items: center;\n      }\n\n      .btn-agcy {\n        font: 20px $semibold;\n        @include mq(mobile) {\n          font-size: 16px;\n        }\n        transition: 0.3s;\n        &:hover {\n          color: #666;\n        }\n      }\n    }\n  }\n  .client-list {\n    padding: 40px 20px;\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    flex-wrap: wrap;\n    position: relative;\n    min-height: 120px;\n  }\n  .btn-clear-agcy {\n    transition: all 0.2s ease;\n    text-decoration: underline;\n    font-size: 14px;\n    &:hover {\n      color: gray;\n    }\n  }\n  .agency-client-column{\n    li{\n      margin-bottom: 10px;\n    }\n  }\n  .cta-wrap{\n    @include mq(desktop){\n      display: flex;\n      justify-content: flex-end;\n      flex:0.2;\n    }\n  }\n}\n\n//\n.select-work-section {\n  padding-top: 50px;\n  padding-bottom: 50px;\n  background-image: url(\"../images/01/login-head.png\");\n  background-size: 100% 60%;\n  background-position-y: 60%;\n  background-repeat: no-repeat;\n  .select-work-wrapper {\n    .slider-head-copy {\n      font-size: 40px;\n      font-family: $semibold;\n      @include mq(mobile){\n        font-size: 24px;\n      }\n    }\n    .slider-container {\n      position: relative;\n      overflow: hidden;\n      @include mq(mobile) {\n        padding: 30px 0;\n      }\n      .flex-slide-item {\n        display: flex !important;\n        justify-content: space-around;\n        align-items: center;\n        @include mq(mobile) {\n          flex-direction: column;\n        }\n\n        .left-copy {\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 10px;\n          padding-bottom: 40px;\n          @include mq(mobile) {\n            flex: 1;\n          }\n          .head-wrap {\n            display: flex;\n            gap: 10px;\n            align-items: center;\n\n            font-size: 20px;\n            .tag {\n              font-family: $regular;\n              text-transform: capitalize;\n            }\n            .title {\n              font-family: $light;\n              text-transform: capitalize;\n            }\n            @include mq(mobile){\n              font-size: 18px;\n            }\n          }\n          .link-project {\n            background-color: black;\n            color: white;\n            border-radius: 20px;\n            padding: 8px 20px;\n            font-family: $semibold;\n            font-size: 20px;\n            margin-top: 20px;\n            transition: 0.3s;\n            &:hover {\n              background-color: white;\n              color: black;\n            }\n\n            @include mq(mobile){\n              font-size: 16px;\n            }\n          }\n        }\n\n        .img-slider {\n          flex: 2;\n          display: flex;\n          align-items: center;\n          justify-content: flex-end;\n\n          img {\n            // width: 300px;\n            border-radius: 10px;\n          }\n        }\n      }\n      .slick-track,\n      .slick-list {\n        -webkit-perspective: 2000px;\n        -webkit-backface-visibility: hidden;\n        display: flex;\n        align-items: center;\n      }\n      .control-wrappar {\n        position: absolute;\n        bottom: 100px;\n        // top: 0;\n        left: 280px;\n\n        @include mq(mobile) {\n          top: 135px;\n          right: 50px;\n          left: unset;\n        }\n        button {\n          border: none;\n          cursor: pointer;\n          font-size: 20px;\n        }\n      }\n    }\n  }\n}\n\n.spinner {\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n\n  span {\n    display: block;\n    width: 30px;\n    height: 30px;\n    border: 3px solid transparent;\n    border-radius: 50%;\n    border-right-color: #000000b3;\n    animation: spinner-anim 0.8s linear infinite;\n  }\n\n  &.spinner-int {\n    top: 85%;\n  }\n  &.spinner-news {\n    top: 85%;\n  }\n}\n\n@keyframes spinner-anim {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n// RESET\n.reset-page {\n  padding-top: 120px;\n  background: url(\"../images/01/dots.png\"), url(\"../images/01/login-head.png\");\n  background-position: top;\n  background-size: 100%, 100% 80%;\n  background-repeat: no-repeat;\n\n  .wrapper-login {\n    width: 100%;\n    .hero-section {\n      // padding-top: 99px;\n      padding-bottom: 40px;\n\n      .hero-copy {\n        // background-color: #fedeff;\n        text-align: center;\n\n        h2 {\n          margin-top: 20px;\n          font-family: $semibold;\n          font-size: 60px;\n          margin-bottom: 20px;\n          @include mq(mobile) {\n            font-size: 26px;\n            margin: 10px 0;\n          }\n        }\n        p {\n          font-family: $regular;\n          font-size: 24px;\n          @include mq(mobile) {\n            font-size: 16px;\n          }\n        }\n      }\n    }\n  }\n  .back-shape {\n    position: absolute;\n    right: 450px;\n    top: 350px;\n    width: 300px;\n    // z-index: 5;\n  }\n  .form-wrapper {\n    position: relative;\n    // z-index: 10;\n    // padding-top: 100px;\n    border: 1px solid black;\n    border-radius: 20px;\n    padding: 35px;\n    // padding-top: 40px;\n    // padding-bottom: 40px;\n    max-width: 500px;\n    height: 450px;\n    margin-bottom: 60px;\n    box-shadow: 8px 8px black;\n    background-color: white;\n    @include mq(mobile) {\n      max-width: 325px;\n      padding: 25px;\n      height: unset;\n    }\n\n    .login-copy {\n      font-family: $semibold;\n      text-align: center;\n      font-size: 34px;\n      @include mq(mobile) {\n        font-size: 24px;\n      }\n    }\n    .login-para {\n      font-size: 14px;\n      text-align: center;\n      margin-top: 20px;\n    }\n    .err-inpt-wrap {\n      position: relative;\n      .err-div {\n        position: absolute;\n        font-size: 12px;\n        color: rgb(255, 0, 0);\n        @include mq(mobile) {\n          font-size: 14px;\n        }\n      }\n    }\n    .input-field {\n      width: 100%;\n      font-family: $regular;\n      color: black;\n      font-size: 20px;\n      border-bottom: 1px solid black;\n      margin-bottom: 10px;\n      margin-top: 40px;\n      @include mq(mobile) {\n        margin-top: 30px;\n        font-size: 16px;\n      }\n    }\n    .btn {\n      margin-top: 40px;\n      width: 100%;\n      border: 1px solid black;\n      outline: none;\n      padding: 10px 20px;\n      font-size: 24px;\n      background-color: #fedeff;\n      border-radius: 10px;\n      box-shadow: 2px 2px black;\n      transition: 0.3s;\n      cursor: pointer;\n      @include mq(mobile) {\n        margin-top: 30px;\n        font-size: 16px;\n      }\n      &:hover {\n        background-color: black;\n        color: #fedeff;\n      }\n    }\n    .forgot-copy {\n      margin-top: 20px;\n      text-align: center;\n      @include mq(mobile) {\n        font-size: 13px;\n      }\n\n      span {\n        display: inline-block;\n        cursor: pointer;\n        &:hover {\n          // text-decoration: underline;\n          border-bottom: 1px solid black;\n          transition: 0.1s;\n        }\n      }\n    }\n  }\n  .login-footer {\n    position: relative;\n    min-height: 90px;\n  }\n}\n\n.not-found-container{\n  padding-top: 140px;\n  padding-bottom: 140px;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding-left: 15px;\n  padding-right: 15px;\n  @include flexbox();\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  .copy-wrap{\n    @include flexbox();\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    h1{\n      font-size: 34px;\n      font-family: $semibold;\n      margin-bottom: 10px;\n    }\n    p{\n      font-size: 20px;\n      font-family: $medium;\n    }\n  }\n  a{\n    border: 1px solid black;\n    padding: 5px 15px;\n    border-radius: 20px;\n    cursor: pointer;\n    font: 16px $regular;\n    transition: all 0.3s ease;\n    align-self: center;\n    &:hover{\n      background: black;\n      color: white;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
